import React, { useState, useEffect, useRef, useCallback } from 'react';
import {
  EditNote, RemoveRedEye, Cancel, DeleteForever, RecentActors, Message,
  WarningAmber, Send, Person, Menu, MenuOpen, Phone, Chat, Facebook,
  Twitter, Instagram, Search, MoreVert, Circle, CheckCircle, AccessTime,
  Business, Note, Refresh, NotificationsActive, NotificationsNone, Archive,
  History, Close
} from '@mui/icons-material';
import {
  Table, TableBody, TableCell, TableContainer, TableHead, TableRow,
  TablePagination, TextField, Button, MenuItem, Modal, Autocomplete,
  Tabs, Tab, Typography, Grid, Box, CssBaseline, Divider, Snackbar,
  Alert, Select, InputLabel, FormControl, Chip, Avatar, IconButton,
  Badge, Tooltip, Icon
} from '@mui/material';
import modalStyle from '../Components/ModalStyle';
import modalStyleLarge from '../Components/ModalStyleLarge';
import axios from 'axios';
import { global_link, socket_base_url, socketiopath } from '../Components/Globallink';
import { format, isToday, isYesterday, differenceInDays } from 'date-fns';
import io from 'socket.io-client';

const Integrations = () => {
  const [activeTab, setActiveTab] = useState(0);
  const [activeMiniTab, setActiveMiniTab] = useState(0);
  const [activeMini2Tab, setActiveMini2Tab] = useState(0);
  const [activeMini3Tab, setActiveMini3Tab] = useState(0);
  const [activeMini4Tab, setActiveMini4Tab] = useState(0);
  const [activeMini5Tab, setActiveMini5Tab] = useState(0);
  const [activeMini6Tab, setActiveMini6Tab] = useState(0);
  const [headerResults, setHeaderResults] = useState([]);
  const [templateData, setTemplateData] = useState([]);
  const [data, setData] = useState([]);
  const [openAddTemplateModal, setAddTemplateModal] = useState(false);
  const [openEditTemplateModal, setEditTemplateModal] = useState(false);
  const [openMessageInfoModal, setMessageInfoModal] = useState(false);
  const [templateListData, setTemplateListData] = useState([]);
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [searchTemplateTerm, setSearchTemplateTerm] = useState('');
  const [searchTerm, setSearchTerm] = useState('');
  const [totalTemplateItems, setTotalTemplateItems] = useState(0);
  const [totalItems, setTotalItems] = useState(0);
  const [selectedItem, setSelectedItem] = useState(null);
  const [selectedOutboxItem, setSelectedOutboxItem] = useState(null);
  const [openBulkContactModal, setBulkContactModal] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [enableDisableButton, setEnableDisableButton] = useState('');
  const [uploadButtonStatus, setUploadButtonStatus] = useState('Submit');
  const [campaignName, setCampaignName] = useState('');
  const [contactCampaignData, setContactCampaignData] = useState([]);
  const [campaignData, setCampaignData] = useState([]);
  const [totalCampaignContactItems, setTotalCampaignContactItems] = useState(0);
  const [totalContactCampaignItems, setTotalContactCampaignItems] = useState(0);
  const [contactModal, setContactModal] = useState(false);
  const [tableCampaignName, setTableCampaignName] = useState('Campaign');
  const [tableCampaignId, setTableCampaignId] = useState('');
  const [tempContentValue, setTempContentValue] = useState('');
  const [contactMethod, setContactMethod] = useState('');
  const [phoneNumber, setPhoneNumber] = useState('');
  const [selectedNumbers, setSelectedNumbers] = useState([]);
  const [selectedContacts, setSelectedContacts] = useState([]);
  const [contactOptions, setContactOptions] = useState([]);
  const [campaignContactList, setCampaignContactList] = useState([]);
  const [scheduledData, setScheduledData] = useState([]);
  const [totalScheduled, setTotalScheduled] = useState(0);
  const [contactMessageModal, setContactMessageModal] = useState(false);
  const [scheduleModal, setScheduleModal] = useState(false);
  const [scheduleEditModal, setScheduleEditModal] = useState(false);
  const [contactConfirmModal, setContactConfirmModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [whatsAppMessagesData, setWhatsAppMessagesData] = useState([]);
  const [openAddChatModal, setAddChatModal] = useState(false);
  const [contactData, setContactData] = useState([]);
  const messagesEndRef = useRef(null);
  const contactSetRef = useRef(null);
  const socketRef = useRef(null);
  const api = axios.create({ baseURL: global_link });
  const authToken = process.env.AUTH_TOKEN;
  const authyToken = localStorage.getItem(authToken);
  
  // WhatsApp State
  const [whatsAppContacts, setWhatsAppContacts] = useState([]);
  const [selectedContact, setSelectedContact] = useState(null);
  const [messages, setMessages] = useState([]);
  const [newMessage, setNewMessage] = useState('');
  const [searchWhatsAppTerm, setSearchWhatsAppTerm] = useState('');
  const [searchContactTerm, setSearchContactTerm] = useState('');
  const [totalContactItems, setTotalContactItems] = useState(0);
  const [openWait, setOpenWait] = useState(false);
  const [openSuccess, setOpenSuccess] = useState(false);
  const [openError, setOpenError] = useState(false);
  
  // ─── Webchat State ───────────────────────────────────────────────
  const [webchatQueues, setWebchatQueues] = useState([]);
  const [selectedWebchat, setSelectedWebchat] = useState(null);
  const webchatContactRef = useRef(null);
  const [webchatMessages, setWebchatMessages] = useState([]);
  const [newWebchatMessage, setNewWebchatMessage] = useState('');
  const [searchWebchatTerm, setSearchWebchatTerm] = useState('');
  const webchatMessagesEndRef = useRef(null);
  
  // UPDATED: Inline Archived Webchat State (replaces Drawer)
  const [showArchivedQueue, setShowArchivedQueue] = useState(false);
  const [archivedWebchatSessions, setArchivedWebchatSessions] = useState([]);
  const [selectedArchivedChat, setSelectedArchivedChat] = useState(null);
  const [archivedMessages, setArchivedMessages] = useState([]);
  const [archivedSearchTerm, setArchivedSearchTerm] = useState('');
  const [archivedPage, setArchivedPage] = useState(0);
  const [archivedRowsPerPage, setArchivedRowsPerPage] = useState(10);
  const [totalArchivedItems, setTotalArchivedItems] = useState(0);
  const [archivedLoading, setArchivedLoading] = useState(false);
  const archivedMessagesEndRef = useRef(null);
  
  // Webchat notification state
  const [webchatUnreadCount, setWebchatUnreadCount] = useState(0);
  const [notificationPermission, setNotificationPermission] = useState(false);
  const [showNotificationBadge, setShowNotificationBadge] = useState(false);
  const webchatSocketRef = useRef(null);
  const notificationSoundRef = useRef(null);
  
  // 🔔 NEW: Snackbar notification state for webchat
  const [webchatSnackbar, setWebchatSnackbar] = useState({
    open: false,
    message: '',
    sender: '',
    sessionId: null
  });
  
  // ─── MS Dynamics State ───────────────────────────────────────────
  const [dynamicsSearch, setDynamicsSearch] = useState('');
  const [dynamicsContact, setDynamicsContact] = useState(null);
  const [dynamicsActivities, setDynamicsActivities] = useState([]);
  const [dynamicsSearchResults, setDynamicsSearchResults] = useState([]);
  const [dynamicsLoading, setDynamicsLoading] = useState(false);
  const [addNoteModal, setAddNoteModal] = useState(false);
  const [noteContent, setNoteContent] = useState('');
  
  // ─── Socials State ───────────────────────────────────────────────
  const [socialInbox, setSocialInbox] = useState([]);
  const [selectedSocialItem, setSelectedSocialItem] = useState(null);
  const [socialMessages, setSocialMessages] = useState([]);
  const [newSocialMessage, setNewSocialMessage] = useState('');
  const [socialFilter, setSocialFilter] = useState('all');
  const [socialLoading, setSocialLoading] = useState(false);
  const socialMessagesEndRef = useRef(null);
  const socialContactRef = useRef(null);
  
  const headers = {
    Authorization: `Bearer ${authyToken}`,
    'Content-Type': 'application/json',
  };
  
  // Webchat socket URL
  const WEBCHAT_SOCKET_URL = 'http://localhost:5102';
  
  // TABLE ONE
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  // TABLE TWO
  const [templatepage, setTemplatePage] = useState(0);
  const [templaterowsPerPage, setTemplateRowsPerPage] = useState(10);
  // TABLE THREE
  const [campaignpage, setCampaignPage] = useState(0);
  const [campaignrowsPerPage, setCampaignRowsPerPage] = useState(10);
  // TABLE FOUR
  const [schedulepage, setSchedulePage] = useState(0);
  const [schedulerowsPerPage, setScheduleRowsPerPage] = useState(10);
  // TABLE FIVE
  const [campaignContactpage, setCampaignContactPage] = useState(0);
  const [campaignContactrowsPerPage, setCampaignContactRowsPerPage] = useState(5);
  // TABLE SIX
  const [contactpage, setContactPage] = useState(0);
  const [contactrowsPerPage, setContactRowsPerPage] = useState(10);
  
  const handleChangePage = (event, newPage) => { setPage(newPage); };
  const handleChangeRowsPerPage = (event) => { setRowsPerPage(parseInt(event.target.value, 10)); setPage(0); };
  const handleTemplateChangePage = (event, newPage) => { setTemplatePage(newPage); };
  const handleTemplateChangeRowsPerPage = (event) => { setTemplateRowsPerPage(parseInt(event.target.value, 10)); setTemplatePage(0); };
  const handleCampaignChangePage = (event, newPage) => { setCampaignPage(newPage); };
  const handleCampaignChangeRowsPerPage = (event) => { setCampaignRowsPerPage(parseInt(event.target.value, 10)); setCampaignPage(0); };
  const handleScheduleChangePage = (event, newPage) => { setSchedulePage(newPage); };
  const handleScheduleChangeRowsPerPage = (event) => { setScheduleRowsPerPage(parseInt(event.target.value, 10)); setSchedulePage(0); };
  const handleCampaignContactChangePage = (event, newPage) => { setCampaignContactPage(newPage); fetchSingleContactCampaignData(tableCampaignId); };
  const handleCampaignContactChangeRowsPerPage = (event) => { setCampaignContactRowsPerPage(parseInt(event.target.value, 5)); setCampaignContactPage(0); };
  const handleContactChangePage = (event, newPage) => { setCampaignContactPage(newPage); };
  const handleContactChangeRowsPerPage = (event) => { setContactRowsPerPage(parseInt(event.target.value, 10)); setContactPage(0); };
  const handleClose = () => { setOpenWait(false); setOpenSuccess(false); setOpenError(false); };
  
  // 🔔 NEW: Close webchat snackbar
  const handleCloseWebchatSnackbar = (event, reason) => {
    if (reason === 'clickaway') return;
    setWebchatSnackbar(prev => ({ ...prev, open: false }));
  };
  
  // 🔔 NEW: Navigate to webchat tab from snackbar
  const handleNavigateToWebchat = () => {
    setActiveTab(2);
    setWebchatUnreadCount(0);
    setShowNotificationBadge(false);
    setWebchatSnackbar(prev => ({ ...prev, open: false }));
    updateTabTitle(0);
    fetchWebchatQueues(searchWebchatTerm);
  };
  
  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
    setActiveMiniTab(0);
    if (newValue === 2) {
      setWebchatUnreadCount(0);
      setShowNotificationBadge(false);
      updateTabTitle(0);
      setWebchatSnackbar(prev => ({ ...prev, open: false }));
    }
  };
  const handleMiniTabChange = (event, newValue) => { setActiveMiniTab(newValue); };
  const handleMini2TabChange = (event, newValue) => { setActiveMini2Tab(newValue); };
  const handleMini3TabChange = (event, newValue) => { setActiveMini3Tab(newValue); };
  const handleMini4TabChange = (event, newValue) => { setActiveMini4Tab(newValue); };
  const handleMini5TabChange = (event, newValue) => { setActiveMini5Tab(newValue); };
  const handleMini6TabChange = (event, newValue) => { setActiveMini6Tab(newValue); };
  const handleCloseAddTemplateModal = () => { setAddTemplateModal(false); };
  const handleOpenAddTemplateModal = () => { setAddTemplateModal(true); };
  const handleCloseEditTemplateModal = () => { setEditTemplateModal(false); };
  const handleCloseAddChatModal = () => { setAddChatModal(false); };
  const handleOpenAddChatModal = () => { setAddChatModal(true); };
  const handleOpenEditTemplateModal = (item) => { setEditTemplateModal(true); setSelectedItem(item); };
  const handleCloseMessageInfoModal = () => { setMessageInfoModal(false); };
  const handleOpenMessageInfoModal = (item) => { setMessageInfoModal(true); setSelectedOutboxItem(item); };
  
  useEffect(() => { fetchContactData(); }, [searchContactTerm, startDate, endDate, contactpage, contactrowsPerPage]);
  const fetchContactData = async () => {
    try {
      const authyToken = localStorage.getItem(authToken);
      const response = await api.get('/contact/all', {
        params: { search: searchContactTerm, start_date: startDate, end_date: endDate, limit: contactrowsPerPage, offset: contactpage * contactrowsPerPage },
        headers: { Authorization: `Bearer ${authyToken}` },
      });
      setContactData(response.data.data);
      setTotalContactItems(response.data.total);
    } catch (error) { console.error('Error fetching Contact:', error); }
  };
  const handleInputChange = (event) => { const { name, value } = event.target; };
  const formatMessageDate = (dateString) => {
    const messageDate = new Date(dateString);
    if (isToday(messageDate)) return 'Today';
    else if (isYesterday(messageDate)) return 'Yesterday';
    else if (differenceInDays(new Date(), messageDate) < 7) return format(messageDate, 'EEEE');
    else return format(messageDate, 'dd/MM/yyyy');
  };
  
  // ─── Notification Functions ──────────────────────────────────────
  const requestNotificationPermission = async () => {
    if ('Notification' in window) {
      const permission = await Notification.requestPermission();
      setNotificationPermission(permission === 'granted');
      return permission === 'granted';
    }
    return false;
  };
  const playNotificationSound = () => {
    try {
      const audio = new Audio('/notification.mp3');
      audio.play().catch(e => console.log('Sound play failed:', e));
    } catch (error) { console.log('Sound not available'); }
  };
  const showDesktopNotification = (title, body, tag = 'webchat') => {
    if (!notificationPermission) return;
    if (!document.hidden) return;
    const notification = new Notification(title, {
      body: body,
      icon: '/favicon.ico',
      tag: tag,
      requireInteraction: false,
      silent: false
    });
    notification.onclick = () => {
      window.focus();
      notification.close();
      handleNavigateToWebchat();
    };
    setTimeout(() => notification.close(), 5000);
  };
  const updateTabTitle = (count) => {
    if (count > 0) {
      document.title = `(${count}) CallSuite`;
    } else {
      document.title = 'CallSuite';
    }
  };
  
  
  // ─── UPDATED: Fetch Archived Webchat Sessions ─────────────────────
  const fetchArchivedWebchatSessions = async () => {
    setArchivedLoading(true);
    try {
      const authyToken = localStorage.getItem(authToken);
      const response = await api.get('/webchat/getendedchats', {
        params: {
          search: archivedSearchTerm,
          page: archivedPage + 1,
          limit: archivedRowsPerPage
        },
        headers: { Authorization: `Bearer ${authyToken}` },
      });
      setArchivedWebchatSessions(response.data.data || []);
      setTotalArchivedItems(response.data.total || response.data.data?.length || 0);
    } catch (error) {
      console.error('Error fetching archived webchat sessions:', error);
      setArchivedWebchatSessions([]);
    } finally {
      setArchivedLoading(false);
    }
  };
  
  const fetchArchivedChatMessages = async (session_id) => {
    try {
      const authyToken = localStorage.getItem(authToken);
      const response = await api.get('/webchat/getchatmessages', {
        params: { session_id },
        headers: { Authorization: `Bearer ${authyToken}` },
      });
      setArchivedMessages(response.data);
    } catch (error) {
      console.error('Error fetching archived messages:', error);
      setArchivedMessages([]);
    }
  };
  
  const handleSelectArchivedChat = async (chat) => {
    setSelectedArchivedChat(chat);
    setSelectedWebchat(null);
    await fetchArchivedChatMessages(chat.session_id);
  };
  
// ─── Webchat Handlers ────────────────────────────────────────────
const fetchWebchatQueues = async (search = '') => {
    try {
        const authyToken = localStorage.getItem(authToken);
        const response = await api.get('/webchat/getactivechats', {
            params: { search },
            headers: { Authorization: `Bearer ${authyToken}` },
        });
        setWebchatQueues(response.data);
        
        const totalUnread = response.data.reduce((sum, chat) => sum + (chat.unread_count || 0), 0);
        setWebchatUnreadCount(totalUnread);
        updateTabTitle(totalUnread);
        setShowNotificationBadge(totalUnread > 0);
    } catch (error) { console.error('Error fetching Webchat queues:', error); }
};

// MOVE THIS FUNCTION HERE (before handleSelectWebchat)
const fetchWebchatMessages = async (session_id) => {
    try {
        const authyToken = localStorage.getItem(authToken);
        const response = await api.get('/webchat/getchatmessages', {
            params: { session_id },
            headers: { Authorization: `Bearer ${authyToken}` },
        });
        setWebchatMessages(response.data);
    } catch (error) { console.error('Error fetching Webchat messages:', error); }
};

const handleSelectWebchat = (chat) => {
    setSelectedWebchat(chat);
    setSelectedArchivedChat(null); // Clear archived selection
    webchatContactRef.current = chat.session_id;
    fetchWebchatMessages(chat.session_id);  // Now this works!
    
    if (chat.unread_count > 0) {
        fetchWebchatQueues(searchWebchatTerm);
    }
    
    if (webchatSocketRef.current) {
        webchatSocketRef.current.emit('join_session', { session_id: chat.session_id });
    }
};
  
  const handleSendWebchatMessage = async (event) => {
    event.preventDefault();
    if (!webchatContactRef.current || !newWebchatMessage.trim()) return;
    const message = newWebchatMessage;
    const session_id = webchatContactRef.current;
    try {
      const authyToken = localStorage.getItem(authToken);
      await api.post('/webchat/sendchatmessage', {
        session_id: session_id,
        message: message,
      }, { headers: { Authorization: `Bearer ${authyToken}` } });
      setWebchatMessages((prev) => [...prev, {
        message: message,
        origin: 'outbound',
        date: new Date().toISOString(),
        session_id: session_id,
        sender_name: 'You'
      }]);
      setNewWebchatMessage('');
      if (webchatMessagesEndRef.current) webchatMessagesEndRef.current.scrollIntoView({ behavior: 'smooth' });
    } catch (error) { console.error('Error sending Webchat message:', error); }
  };
  
  const handleEndWebchat = async (session_id) => {
    try {
      const authyToken = localStorage.getItem(authToken);
      await api.post('/webchat/endchat', { session_id }, { headers: { Authorization: `Bearer ${authyToken}` } });
      if (webchatSocketRef.current) webchatSocketRef.current.emit('leave_session', { session_id });
      setSelectedWebchat(null);
      webchatContactRef.current = null;
      setWebchatMessages([]);
      fetchWebchatQueues();
      // Refresh archived sessions if visible
      if (showArchivedQueue) fetchArchivedWebchatSessions();
    } catch (error) { console.error('Error ending Webchat:', error); }
  };
  
  const handleWebchatKeyPress = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) { e.preventDefault(); handleSendWebchatMessage(e); }
  };
  
  useEffect(() => {
    if (activeTab === 2) fetchWebchatQueues(searchWebchatTerm);
  }, [activeTab, searchWebchatTerm]);
  
  // ─── UPDATED: Debounced Archived Search ───────────────────────────
  useEffect(() => {
    if (showArchivedQueue) {
      const timer = setTimeout(() => {
        fetchArchivedWebchatSessions();
      }, 300);
      return () => clearTimeout(timer);
    }
  }, [archivedSearchTerm, archivedPage, archivedRowsPerPage, showArchivedQueue]);
  
  // Webchat Socket Connection with Notifications
  useEffect(() => {
    requestNotificationPermission();
    const authyToken = localStorage.getItem(authToken);
    const socket = io(WEBCHAT_SOCKET_URL, {
      auth: { token: authyToken },
      transports: ['websocket']
    });
    webchatSocketRef.current = socket;
    
    socket.on('new_visitor_message', (data) => {
      console.log('[Webchat] New visitor message received:', data);
      playNotificationSound();
      showDesktopNotification(
        `💬 New message from ${data.sender}`,
        data.message.length > 50 ? data.message.slice(0, 50) + '...' : data.message,
        `webchat_${data.session_id}`
      );
      if (activeTab !== 2) {
        setWebchatSnackbar({ open: true, message: data.message, sender: data.sender, sessionId: data.session_id });
      }
      fetchWebchatQueues(searchWebchatTerm);
      if (webchatContactRef.current === data.session_id) {
        setWebchatMessages((prev) => [...prev, {
          message: data.message, origin: 'inbound', date: data.timestamp,
          session_id: data.session_id, sender_name: data.sender
        }]);
      } else {
        setWebchatUnreadCount(prev => prev + 1);
        updateTabTitle(webchatUnreadCount + 1);
        setShowNotificationBadge(true);
      }
    });
    socket.on('session_ended', (data) => {
      console.log('[Webchat] Session ended:', data);
      fetchWebchatQueues(searchWebchatTerm);
      if (webchatContactRef.current === data.session_id) {
        setSelectedWebchat(null);
        webchatContactRef.current = null;
        setWebchatMessages([]);
      }
      if (showArchivedQueue) fetchArchivedWebchatSessions();
    });
    
    const handleVisibilityChange = () => {
      if (!document.hidden && activeTab === 2) {
        setWebchatUnreadCount(0);
        setShowNotificationBadge(false);
        updateTabTitle(0);
        setWebchatSnackbar(prev => ({ ...prev, open: false }));
      }
    };
    document.addEventListener('visibilitychange', handleVisibilityChange);
    return () => {
      if (webchatSocketRef.current) webchatSocketRef.current.disconnect();
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, [activeTab, searchWebchatTerm, webchatUnreadCount]);
  
  // ─── MS Dynamics Handlers ────────────────────────────────────────
  const handleDynamicsSearch = async () => {
    if (!dynamicsSearch.trim()) return;
    setDynamicsLoading(true);
    try {
      const authyToken = localStorage.getItem(authToken);
      const response = await api.get('/dynamics/searchcontact', {
        params: { search: dynamicsSearch },
        headers: { Authorization: `Bearer ${authyToken}` },
      });
      setDynamicsSearchResults(response.data);
    } catch (error) { console.error('Error searching Dynamics contact:', error); }
    finally { setDynamicsLoading(false); }
  };
  const handleSelectDynamicsContact = async (contact) => {
    setDynamicsContact(contact);
    try {
      const authyToken = localStorage.getItem(authToken);
      const response = await api.get(`/dynamics/getcontactactivities/${contact.id}`, {
        headers: { Authorization: `Bearer ${authyToken}` },
      });
      setDynamicsActivities(response.data);
    } catch (error) { console.error('Error fetching Dynamics activities:', error); }
  };
  const handleAddDynamicsNote = async () => {
    if (!dynamicsContact || !noteContent.trim()) return;
    try {
      const authyToken = localStorage.getItem(authToken);
      await api.post('/dynamics/addnote', {
        contact_id: dynamicsContact.id, note: noteContent,
      }, { headers: { Authorization: `Bearer ${authyToken}` } });
      setNoteContent(''); setAddNoteModal(false);
      handleSelectDynamicsContact(dynamicsContact);
    } catch (error) { console.error('Error adding Dynamics note:', error); }
  };
  
  // ─── Socials Handlers ────────────────────────────────────────────
  const fetchSocialInbox = async (platform = 'all', search = '') => {
    setSocialLoading(true);
    try {
      const authyToken = localStorage.getItem(authToken);
      const response = await api.get('/socials/getinbox', {
        params: { platform, search },
        headers: { Authorization: `Bearer ${authyToken}` },
      });
      setSocialInbox(response.data);
    } catch (error) { console.error('Error fetching Social inbox:', error); }
    finally { setSocialLoading(false); }
  };
  const fetchSocialMessages = async (thread_id, platform) => {
    try {
      const authyToken = localStorage.getItem(authToken);
      const response = await api.get('/socials/getthreadmessages', {
        params: { thread_id, platform },
        headers: { Authorization: `Bearer ${authyToken}` },
      });
      setSocialMessages(response.data);
    } catch (error) { console.error('Error fetching Social thread:', error); }
  };
  const handleSelectSocialItem = (item) => {
    setSelectedSocialItem(item);
    socialContactRef.current = item.thread_id;
    fetchSocialMessages(item.thread_id, item.platform);
  };
  const handleSendSocialReply = async (event) => {
    event.preventDefault();
    if (!selectedSocialItem || !newSocialMessage.trim()) return;
    try {
      const authyToken = localStorage.getItem(authToken);
      await api.post('/socials/reply', {
        thread_id: selectedSocialItem.thread_id, platform: selectedSocialItem.platform,
        message: newSocialMessage, reply_to_id: selectedSocialItem.source_id,
      }, { headers: { Authorization: `Bearer ${authyToken}` } });
      setNewSocialMessage('');
      fetchSocialMessages(selectedSocialItem.thread_id, selectedSocialItem.platform);
    } catch (error) { console.error('Error sending Social reply:', error); }
  };
  const handleSocialKeyPress = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) { e.preventDefault(); handleSendSocialReply(e); }
  };
  useEffect(() => { if (activeTab === 4) fetchSocialInbox(socialFilter); }, [activeTab, socialFilter]);
  useEffect(() => {
    const authyToken = localStorage.getItem(authToken);
    const socket = io(socket_base_url, { socketiopath, auth: { token: authyToken }, transports: ['websocket'] });
    socket.on('SOCIAL_NEW_MESSAGE', (data) => {
      fetchSocialInbox(socialFilter);
      if (socialContactRef.current === data.thread_id) {
        setSocialMessages((prev) => [...prev, { message: data.message, origin: 'inbound', date: data.date, platform: data.platform, sender_name: data.sender_name }]);
      }
    });
    return () => { socket.disconnect(); };
  }, [socialFilter]);
  
  // WhatsApp existing handlers (unchanged)
  const fetchTemplateList = async () => {
    try {
      const authyToken = localStorage.getItem(authToken);
      const response = await api.get('sms/getsmstemplatelist', { headers: { Authorization: `Bearer ${authyToken}`, "Content-Type": "application/json" } });
      setTemplateListData(response.data);
    } catch (error) { console.error('Error fetching Template List:', error); }
  };
  const fetchTemplateData = async () => {
    try {
      const authyToken = localStorage.getItem(authToken);
      const response = await api.get('/sms/getsmstemplates', {
        params: { search: searchTemplateTerm, start_date: startDate, end_date: endDate, limit: templaterowsPerPage, offset: templatepage * templaterowsPerPage },
        headers: { Authorization: `Bearer ${authyToken}` },
      });
      setTemplateData(response.data.data);
      setTotalTemplateItems(response.data.total);
    } catch (error) { console.error('Error fetching Templates:', error); }
  };
  const fetchScheduleData = async () => {
    try {
      const authyToken = localStorage.getItem(authToken);
      const response = await api.get('/sms/getsmsschedule', {
        params: { search: searchTemplateTerm, start_date: startDate, end_date: endDate, limit: schedulerowsPerPage, offset: schedulepage * schedulerowsPerPage },
        headers: { Authorization: `Bearer ${authyToken}` },
      });
      setScheduledData(response.data.data);
      setTotalScheduled(response.data.total);
    } catch (error) { console.error('Error fetching Schedule:', error); }
  };
  useEffect(() => { if (messagesEndRef.current) messagesEndRef.current.scrollIntoView({ behavior: "smooth" }); }, [whatsAppMessagesData]);
  useEffect(() => { if (webchatMessagesEndRef.current) webchatMessagesEndRef.current.scrollIntoView({ behavior: "smooth" }); }, [webchatMessages]);
  useEffect(() => { if (socialMessagesEndRef.current) socialMessagesEndRef.current.scrollIntoView({ behavior: "smooth" }); }, [socialMessages]);
  useEffect(() => { if (archivedMessagesEndRef.current && archivedMessages.length > 0) archivedMessagesEndRef.current.scrollIntoView({ behavior: "smooth" }); }, [archivedMessages]);
  
  const fetchContactCampaignData = async () => {
    try {
      const authyToken = localStorage.getItem(authToken);
      const response = await api.get('/sms/getcontactcampaignnames', {
        params: { search: searchTemplateTerm, start_date: startDate, end_date: endDate, limit: campaignrowsPerPage, offset: campaignpage * campaignrowsPerPage },
        headers: { Authorization: `Bearer ${authyToken}` },
      });
      setContactCampaignData(response.data.data);
      setTotalContactCampaignItems(response.data.total);
    } catch (error) { console.error('Error fetching Campaign Data:', error); }
  };
  const fetchOutboxData = async () => {
    try {
      const authyToken = localStorage.getItem(authToken);
      const response = await api.get('/sms/getsms', {
        params: { search: searchTerm, start_date: startDate, end_date: endDate, limit: rowsPerPage, offset: page * rowsPerPage },
        headers: { Authorization: `Bearer ${authyToken}` },
      });
      setData(response.data.data);
      setTotalItems(response.data.total);
    } catch (error) { console.error('Error fetching Outbox:', error); }
  };
  const handleTemplateSubmit = (event) => {
    event.preventDefault();
    const formData = new FormData(event.target);
    const authyToken = localStorage.getItem(authToken);
    const headers = { Authorization: `Bearer ${authyToken}`, "Content-Type": "application/json" };
    api.post('/sms/addsmstemplate', formData, { headers, withCredentials: true })
      .then(() => { fetchTemplateData(); fetchTemplateList(); handleCloseAddTemplateModal(false); })
      .catch((error) => { console.error(error); });
  };
  const handleTemplateEditSubmit = (event) => {
    event.preventDefault();
    const formData = new FormData(event.target);
    const authyToken = localStorage.getItem(authToken);
    const headers = { Authorization: `Bearer ${authyToken}`, "Content-Type": "application/json" };
    api.post('/sms/editsmstemplate', formData, { headers, withCredentials: true })
      .then(() => { fetchTemplateData(); fetchTemplateList(); handleCloseEditTemplateModal(false); })
      .catch((error) => { console.error(error); });
  };
  const handleTemplateDelete = (id) => {
    const authyToken = localStorage.getItem(authToken);
    const headers = { Authorization: `Bearer ${authyToken}`, "Content-Type": "application/json" };
    api.delete(`/sms/deletesmstemplate/${id}`, { headers, withCredentials: true })
      .then(() => { fetchTemplateData(); fetchTemplateList(); handleCloseEditTemplateModal(false); })
      .catch((error) => { console.error(error); });
  };
  useEffect(() => {
    fetchTemplateData(); fetchTemplateList(); fetchOutboxData(); fetchContactCampaignData(); fetchCampaignContactList(); fetchScheduleData();
  }, [searchTemplateTerm, startDate, endDate, templatepage, templaterowsPerPage, schedulepage, schedulerowsPerPage, searchTerm, page, rowsPerPage]);
  const handleInputModChange = (event) => {
    const { name, value } = event.target;
    setSelectedItem((prevFormState) => ({ ...prevFormState, [name]: value }));
  };
  const handleCloseBulkContactModal = () => { setBulkContactModal(false); };
  const handleOpenBulkContactModal = () => { setBulkContactModal(true); };
  const handleFileChange = (event) => { setSelectedFile(event.target.files[0]); };
  const downloadTemplate = () => {
    const downloadLink = document.createElement('a');
    downloadLink.href = '/campaign_template.csv';
    downloadLink.download = 'campaign_template.csv';
    downloadLink.click();
  };
  const handleBulkContactSubmit = async (event) => {
    event.preventDefault();
    if (!selectedFile) return;
    const formData = new FormData();
    formData.append("file", selectedFile);
    formData.append("campaignName", campaignName);
    setEnableDisableButton('disabled');
    setUploadButtonStatus('Uploading.. Please Wait. Do Not Leave The Page');
    try {
      const authyToken = localStorage.getItem(authToken);
      const headers = { Authorization: `Bearer ${authyToken}`, "Content-Type": "multipart/form-data" };
      const response = await api.post("/sms/addcampaigncontacts/", formData, { headers, withCredentials: true });
      setBulkContactModal(false); setEnableDisableButton(''); setUploadButtonStatus('Submit');
      fetchContactCampaignData(); fetchCampaignContactList();
    } catch (error) { console.log(`Upload failed: ${error.response?.data?.error || error.message}`); }
  };
  const handleCloseContactModal = (event) => { setContactModal(false); setCampaignData([]); setTableCampaignId(''); };
  const fetchSingleContactCampaignData = async (campaign_id) => {
    try {
      const authyToken = localStorage.getItem(authToken);
      const response = await api.get(`/sms/getcampaigncontact/`, {
        params: { search: searchTemplateTerm, campaign_id, start_date: startDate, end_date: endDate, limit: campaignContactrowsPerPage, offset: campaignContactpage * campaignContactrowsPerPage },
        headers: { Authorization: `Bearer ${authyToken}` },
      });
      setCampaignData(response.data.data);
      setTotalCampaignContactItems(response.data.total);
    } catch (error) { console.error('Error fetching Campaign Contact:', error); }
  };
  const fetchTemplateListContent = async (event) => {
    try {
      const authyToken = localStorage.getItem(authToken);
      const contentvalue = event.target.value;
      const response = await api.get(`/sms/getsmstemplatelistcontent/`, { params: { id: contentvalue }, headers: { Authorization: `Bearer ${authyToken}` } });
      setTempContentValue(response.data.content);
    } catch (error) { console.error('Error fetching Template Content:', error); }
  };
  const fetchCampaignContactList = async () => {
    try {
      const authyToken = localStorage.getItem(authToken);
      const response = await api.get('sms/getsmscontactcampaignselect/', { headers: { Authorization: `Bearer ${authyToken}`, "Content-Type": "application/json" } });
      setCampaignContactList(response.data);
    } catch (error) { console.error('Error fetching Campaign Contact List:', error); }
  };
  const handleOpenContactModal = (campaign_id, campaign_name) => {
    fetchSingleContactCampaignData(campaign_id);
    setTableCampaignName(campaign_name);
    setTableCampaignId(campaign_id);
    setContactModal(true);
  };
  const handleOpenContactMessageModal = (item) => { setSelectedItem(item); setContactMessageModal(true); };
  const handleCloseContactMessageModal = () => { setContactMessageModal(false); };
  const deleteCampaignContact = (id, campaign_id) => {
    const authyToken = localStorage.getItem(authToken);
    const headers = { Authorization: `Bearer ${authyToken}`, "Content-Type": "application/json" };
    api.delete(`/sms/deletecampaigncontact/${id}`, { headers, withCredentials: true })
      .then(() => { fetchSingleContactCampaignData(campaign_id); })
      .catch((error) => { console.error(error); });
  };
  const handleDeleteCampaignContact = (id, campaign_id) => { deleteCampaignContact(id, campaign_id); };
  const handleContactMethod = (event) => { setContactMethod(event.target.value); setPhoneNumber(''); setSelectedNumbers([]); };
  const handleNumberChange = (event) => { setPhoneNumber(event.target.value); };
  useEffect(() => {
    setContactOptions([
      { phone_number: '1234567890' },
      { phone_number: '0987654321' },
      { phone_number: '5555555555' },
    ]);
  }, []);
  const handleContactChange = (event, value) => { setSelectedContacts(value); };
  const handleCloseScheduleModal = () => { setScheduleModal(false); };
  const handleOpenScheduleModal = () => { setScheduleModal(true); };
  const handleCloseEditScheduleModal = () => { setScheduleEditModal(false); };
  const handleOpenEditScheduleModal = (item) => { setScheduleEditModal(true); setSelectedItem(item); };
  const handleSmsScheduleSubmit = (event) => {
    event.preventDefault();
    const formData = new FormData(event.target);
    const authyToken = localStorage.getItem(authToken);
    const headers = { Authorization: `Bearer ${authyToken}`, "Content-Type": "application/json" };
    api.post('/sms/addsmsschedule', formData, { headers, withCredentials: true })
      .then(() => { setScheduleModal(false); fetchScheduleData(); })
      .catch((error) => { console.error(error); });
  };
  const handleEditSmsScheduleSubmit = (event) => {
    event.preventDefault();
    const formData = new FormData(event.target);
    const authyToken = localStorage.getItem(authToken);
    const headers = { Authorization: `Bearer ${authyToken}`, "Content-Type": "application/json" };
    api.post('/sms/editsmsschedule', formData, { headers, withCredentials: true })
      .then(() => { handleCloseEditScheduleModal(); fetchScheduleData(); })
      .catch((error) => { console.error(error); });
  };
  const handleSmsScheduleDelete = (id) => {
    const authyToken = localStorage.getItem(authToken);
    const headers = { Authorization: `Bearer ${authyToken}`, "Content-Type": "application/json" };
    api.delete(`/sms/deletesmsschedule/${id}`, { headers, withCredentials: true })
      .then(() => { handleCloseEditScheduleModal(); fetchScheduleData(); })
      .catch((error) => { console.error(error); });
  };
  const handleCampaignMessageUpdate = (event) => {
    event.preventDefault();
    const formData = new FormData(event.target);
    const authyToken = localStorage.getItem(authToken);
    const headers = { Authorization: `Bearer ${authyToken}`, "Content-Type": "application/json" };
    api.post('/sms/editsmscampaignmessage/', formData, { headers, withCredentials: true })
      .then(() => { handleCloseContactMessageModal(); fetchContactCampaignData(); })
      .catch((error) => { console.error(error); });
  };
  const handleOpenDeleteContactConfirmModal = (item) => { setSelectedItem(item); setContactConfirmModal(true); };
  const handleCloseDeleteContactConfirmModal = () => { setContactConfirmModal(false); };
  const handleDeleteCampaignContacts = (campaign_id) => {
    const authyToken = localStorage.getItem(authToken);
    const headers = { Authorization: `Bearer ${authyToken}`, "Content-Type": "application/json" };
    api.delete(`/sms/deletecampaigncontacts/${campaign_id}`, { headers, withCredentials: true })
      .then(() => { handleCloseDeleteContactConfirmModal(); fetchContactCampaignData(); fetchCampaignContactList(); })
      .catch((error) => { console.error(error); });
  };
  const debounce = (func, delay) => {
    let timeoutId;
    return (...args) => { clearTimeout(timeoutId); timeoutId = setTimeout(() => func.apply(null, args), delay); };
  };
  const fetchWhatsAppContacts = async (searchWhatsAppTerm = '') => {
    setLoading(true);
    try {
      const response = await api.get('/whatsapp/getwhatsappusers', { headers, params: { search: searchWhatsAppTerm.trim() || undefined } });
      setWhatsAppContacts(response.data);
    } catch (error) { console.error('Error fetching WhatsApp contacts:', error); }
    finally { setLoading(false); }
  };
  const debouncedSearch = useCallback(debounce((term) => { fetchWhatsAppContacts(term); }, 300), []);
  const handleSearchChange = (e) => { const value = e.target.value; setSearchWhatsAppTerm(value); debouncedSearch(value); };
  const handleSearchContactChange = (e) => { const value = e.target.value; setSearchContactTerm(value); };
  const clearSearch = () => { setSearchWhatsAppTerm(''); fetchWhatsAppContacts(''); };
  useEffect(() => { if (activeTab === 1) fetchWhatsAppContacts(); }, [activeTab, searchWhatsAppTerm]);
  useEffect(() => {
    const authyToken = localStorage.getItem(authToken);
    const socket = io(socket_base_url, { socketiopath, auth: { token: authyToken }, transports: ['websocket'] });
    socketRef.current = socket;
    socket.on('WHATSAPP_SEND_EVENT_REC', handleOutGoingMessage);
    return () => { socket.disconnect(); };
  }, []);
  const handleSendMessage = useCallback(async (event) => {
    event.preventDefault();
    if (!contactSetRef.current) return;
    try {
      const messageData = { contact_number: contactSetRef.current, text_body: newMessage, type: 'text' };
      await api.post('/whatsapp/addmessage', messageData, { headers, withCredentials: true });
      setNewMessage('');
    } catch (error) { console.error('Error sending message:', error); }
  }, [newMessage]);
  const handleOutGoingMessage = (msgData) => {
    debouncedSearch();
    if (contactSetRef.current === msgData?.contact_number) {
      setWhatsAppMessagesData((prevMessages) => [...prevMessages, { text_body: msgData.text_body, contact_number: msgData.contact_number, origin: msgData.origin, date: msgData.date }]);
    }
  };
  const handleKeyPress = (e) => { if (e.key === 'Enter' && !e.shiftKey) { e.preventDefault(); handleSendMessage(e); setNewMessage(''); } };
  useEffect(() => {
    const authyToken = localStorage.getItem(authToken);
    const socket = io(socket_base_url, { socketiopath, auth: { token: authyToken }, transports: ['websocket'] });
    socket.on('WHATSAPP_RECIEVE_EVENT', (eventData) => {
      if (eventData.type === 'new_message') {
        const messageData = eventData.data;
        debouncedSearch();
        if (contactSetRef.current === eventData.data.contact_number) {
          setWhatsAppMessagesData((prevMessages) => [...prevMessages, { text_body: messageData.text, origin: messageData.origin, date: messageData.date, contact_number: messageData.contact_number }]);
        }
      }
    });
    return () => { socket.disconnect(); };
  }, []);
  const handleFetchWhatsAppMessages = async (contact, contact_number) => {
    setSelectedContact(contact);
    contactSetRef.current = contact_number;
    try {
      const authyToken = localStorage.getItem(authToken);
      const response = await api.get(`/whatsapp/getmessages/`, { params: { contact_number }, headers: { Authorization: `Bearer ${authyToken}` } });
      setWhatsAppMessagesData(response.data);
    } catch (error) { console.error('Error fetching WhatsApp Messages:', error); }
  };
  const handleFetchWhatsAppContactMessages = async (name, phone_number) => {
    handleCloseAddChatModal();
    const contact_data = { contact_name: name, contact_number: phone_number, last_message_date: new Date().toISOString() };
    setSelectedContact(contact_data);
    contactSetRef.current = phone_number;
  };
  const handleSMSSubmit = async (event) => {
    event.preventDefault();
    setOpenWait(true);
    const formData = new FormData(event.target);
    const campaign_name = formData.get('campaign_name');
    const message = formData.get('message');
    try {
      const accessToken = localStorage.getItem(authToken);
      const headers = { Authorization: `Bearer ${accessToken}`, "Content-Type": "application/json" };
      let smsResponse;
      if (campaign_name) {
        smsResponse = await api.post(`/sms/sendsmscampaign`, { campaign_name, message }, { withCredentials: true, headers });
      } else {
        smsResponse = await api.post('/sms/sendsms', { mobile: [formData.get('phone_number')], message }, { withCredentials: true, headers });
      }
      setTimeout(() => {
        setOpenWait(false);
        if (smsResponse.status === 200) {
          setOpenSuccess(true);
          document.getElementById('contact-form')?.reset();
          setSelectedNumbers(""); setContactMethod(""); setPhoneNumber(""); setTempContentValue("");
          fetchOutboxData();
        } else { setOpenError(true); }
      }, 10000);
    } catch (error) {
      console.error('Error:', error);
      setTimeout(() => { setOpenWait(false); setOpenError(true); }, 10000);
    }
  };
  const copyPhoneNumber = (call_from, call_to) => {
    const phoneNumber = call_from.length > 5 ? call_from : call_to;
    const event = new CustomEvent('copyPhoneNumber', { detail: phoneNumber });
    window.dispatchEvent(event);
  };
  const getPlatformIcon = (platform) => {
    switch (platform) {
      case 'facebook': return <Facebook sx={{ fontSize: '1rem', color: '#1877F2' }} />;
      case 'instagram': return <Instagram sx={{ fontSize: '1rem', color: '#E1306C' }} />;
      case 'twitter': return <Twitter sx={{ fontSize: '1rem', color: '#1DA1F2' }} />;
      default: return null;
    }
  };
  const getPlatformColor = (platform) => {
    switch (platform) {
      case 'facebook': return '#1877F2';
      case 'instagram': return '#E1306C';
      case 'twitter': return '#1DA1F2';
      default: return '#999';
    }
  };
  const getSourceTypeLabel = (source_type) => {
    switch (source_type) {
      case 'dm': return 'DM';
      case 'comment': return 'Comment';
      case 'mention': return 'Mention';
      default: return source_type;
    }
  };

  return (
    <>
      <CssBaseline />
      <Tabs value={activeTab} onChange={handleTabChange} variant="fullWidth" aria-label="Integration Tabs" sx={{ padding: '2px', marginBottom: '15px' }}>
        <Tab label="SMS" />
        <Tab label="WhatsApp" />
        <Tab label={<Badge badgeContent={webchatUnreadCount} color="error" invisible={!showNotificationBadge}>Webchat</Badge>} />
        <Tab label="MS Dynamics" />
        <Tab label="Socials" />
      </Tabs>
      
      {/* ═══════════════════════════════════════════════════════ */}
      {/* TAB 0 — SMS (unchanged)                                 */}
      {/* ═══════════════════════════════════════════════════════ */}
      {activeTab === 0 && (
        <Grid container spacing={3}>
          <Grid item xs={12} md={12}>
            <Box sx={{ bgcolor: 'background.paper', boxShadow: 'none', border: `0.1px solid rgba(207, 211, 212, 0.2)`, borderRadius: '5px' }}>
              <Tabs value={activeMini2Tab} onChange={handleMini2TabChange} variant="fullWidth" aria-label="SMS Tabs" sx={{ padding: '0px' }}>
                <Tab label="Create" />
                <Tab onClick={() => fetchOutboxData} label="Outbox" />
                <Tab onClick={() => fetchTemplateData} label="Templates" />
                <Tab onClick={() => fetchContactCampaignData} label="Campaign Contacts" />
              </Tabs>
              {activeMini2Tab === 0 && (
                <form id="contact-form" onSubmit={handleSMSSubmit}>
                  <Grid container spacing={2} p={2}>
                    <Grid item xs={6}>
                      <TextField fullWidth select label="Template" name="template" sx={{ marginTop: "5px" }} onChange={fetchTemplateListContent}>
                        <MenuItem value="" disabled>Select Template</MenuItem>
                        {templateListData.map((templateinfo, i) => (<MenuItem key={i} value={templateinfo.id}>{templateinfo.name}</MenuItem>))}
                      </TextField>
                    </Grid>
                    <Grid item xs={6}>
                      <TextField fullWidth select label="Select Contact Method" name="keyword" sx={{ marginTop: "5px" }} required value={contactMethod} onChange={handleContactMethod}>
                        <MenuItem disabled>Contact Method</MenuItem>
                        <MenuItem value="input_number">Input Number</MenuItem>
                        {contactCampaignData.length > 0 && <MenuItem value="from_campaign">Campaign Contacts</MenuItem>}
                      </TextField>
                    </Grid>
                    <Grid item xs={12}>
                      {contactMethod === 'input_number' && (<TextField fullWidth label="Phone Number" name="phone_number" value={phoneNumber} onChange={handleNumberChange} />)}
                      {contactMethod === 'from_campaign' && (
                        <TextField fullWidth select label="Campaign" name="campaign_name">
                          <MenuItem value="" disabled>Select Campaign</MenuItem>
                          {campaignContactList.map((campaigninfo, i) => (<MenuItem key={i} value={campaigninfo.campaign_id}>{campaigninfo.campaign_name}</MenuItem>))}
                        </TextField>
                      )}
                    </Grid>
                    <Grid item xs={12}>
                      <TextField multiline rows={4} label="Textarea" placeholder="SMS" variant="outlined" fullWidth name="message" value={tempContentValue} required onChange={(e) => setTempContentValue(e.target.value)} />
                    </Grid>
                    <Grid item xs={12}>
                      <Button variant="contained" fullWidth type="submit" disabled={openWait} sx={{ padding: '10px', marginTop: '12px' }}>{openWait ? 'Sending...' : 'Send SMS'}</Button>
                    </Grid>
                  </Grid>
                </form>
              )}
              {activeMini2Tab === 1 && (
                <>
                  <TableContainer>
                    <Table sx={{ fontSize: '5.1rem !important' }} size="small">
                      <TableHead sx={{ bgcolor: 'background.table', width: '100%' }}>
                        <TableRow>
                          <TableCell>#</TableCell><TableCell>Message</TableCell><TableCell>Status</TableCell><TableCell>Date</TableCell><TableCell>Action</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {data.length > 0 ? data.map((row) => (
                          <TableRow key={row.id}>
                            <TableCell>{row.id}</TableCell>
                            <TableCell>{`${row.message.slice(0, 50)} ...`}</TableCell>
                            <TableCell>{row.status}</TableCell>
                            <TableCell>{row.date}</TableCell>
                            <TableCell><Button onClick={() => handleOpenMessageInfoModal(row)} variant="contained" color="info" sx={{ padding: '1px', margin: '5px' }}><RemoveRedEye sx={{ fontSize: '1.5rem', cursor: 'pointer', margin: '5px' }} /></Button></TableCell>
                          </TableRow>
                        )) : (<TableRow><TableCell colSpan={7} align="center">No matching records found</TableCell></TableRow>)}
                      </TableBody>
                    </Table>
                  </TableContainer>
                  <TablePagination component="div" count={totalItems} page={page} onPageChange={handleChangePage} rowsPerPage={rowsPerPage} onRowsPerPageChange={handleChangeRowsPerPage} rowsPerPageOptions={[10, 50, 100]} />
                  <Modal open={openMessageInfoModal} onClose={handleCloseMessageInfoModal}>
                    <Box sx={modalStyle}>
                      <Box sx={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                        <h3>Message Info</h3><Cancel onClick={handleCloseMessageInfoModal} sx={{ cursor: 'pointer' }} />
                      </Box>
                      {selectedOutboxItem && (
                        <Grid container spacing={1}>
                          <Grid item xs={6}><TextField label="Recipient" fullWidth value={selectedOutboxItem.recipient || ""} sx={{ marginTop: "5px" }} /></Grid>
                          <Grid item xs={6}><TextField label="Date" fullWidth value={selectedOutboxItem.date || ""} sx={{ marginTop: "5px" }} /></Grid>
                          <Grid item xs={12}><TextField multiline rows={3} label="Message" fullWidth value={selectedOutboxItem.message || ""} sx={{ marginTop: "5px" }} /></Grid>
                          <Grid item xs={12}><Button variant="outlined" fullWidth color="success" sx={{ fontWeight: 'bold' }} onClick={() => { copyPhoneNumber(selectedOutboxItem.recipient); handleCloseMessageInfoModal(); }}>CALL</Button></Grid>
                        </Grid>
                      )}
                    </Box>
                  </Modal>
                </>
              )}
              {activeMini2Tab === 2 && (
                <>
                  <Box sx={{ display: 'flex', justifyContent: 'flex-end', p: 2 }}>
                    <Button variant="contained" sx={{ width: '30%!important' }} color='primary' onClick={handleOpenAddTemplateModal}>Add Template</Button>
                  </Box>
                  <TableContainer>
                    <Table sx={{ fontSize: '5.1rem !important' }} size="small">
                      <TableHead sx={{ bgcolor: 'background.table', width: '100%' }}>
                        <TableRow><TableCell>Name</TableCell><TableCell>Content</TableCell><TableCell>Date</TableCell><TableCell>Action</TableCell></TableRow>
                      </TableHead>
                      <TableBody>
                        {templateData.length > 0 ? templateData.map((row) => (
                          <TableRow key={row.id}>
                            <TableCell>{row.name}</TableCell><TableCell>{row.content}</TableCell><TableCell>{row.date}</TableCell>
                            <TableCell><Button onClick={() => handleOpenEditTemplateModal(row)} variant="contained" color="info" sx={{ padding: '1px', margin: '5px' }}><RemoveRedEye sx={{ fontSize: '1.5rem', cursor: 'pointer', margin: '5px' }} /></Button></TableCell>
                          </TableRow>
                        )) : (<TableRow><TableCell colSpan={7} align="center">No matching records found</TableCell></TableRow>)}
                      </TableBody>
                    </Table>
                  </TableContainer>
                  <TablePagination component="div" count={totalTemplateItems} page={templatepage} onPageChange={handleTemplateChangePage} rowsPerPage={templaterowsPerPage} onRowsPerPageChange={handleTemplateChangeRowsPerPage} rowsPerPageOptions={[10, 50, 100]} labelRowsPerPage="Rows per page" />
                  <Modal open={openAddTemplateModal} onClose={handleCloseAddTemplateModal}>
                    <Box sx={modalStyle}>
                      <Box sx={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                        <h3>Add Template</h3><Cancel onClick={handleCloseAddTemplateModal} sx={{ cursor: 'pointer' }} />
                      </Box>
                      <form onSubmit={handleTemplateSubmit}>
                        <Grid container spacing={1}>
                          <Grid item xs={12}><TextField label="Template Name" name="template_name" onChange={handleInputChange} fullWidth required sx={{ marginTop: "5px" }} /></Grid>
                          <Grid item xs={12}><TextField multiline rows={3} label="Template Content" fullWidth name="content" onChange={handleInputChange} sx={{ marginTop: "5px" }} /></Grid>
                          <Grid item xs={12}><Button type="submit" variant="contained" color='info' sx={{ padding: "10px", marginTop: "10px", width: "100%" }}>Add Template</Button></Grid>
                        </Grid>
                      </form>
                    </Box>
                  </Modal>
                  <Modal open={openEditTemplateModal} onClose={handleCloseEditTemplateModal}>
                    <Box sx={modalStyle}>
                      <Box sx={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                        <h3>Edit Template</h3><Cancel onClick={handleCloseEditTemplateModal} sx={{ cursor: 'pointer' }} />
                      </Box>
                      <form onSubmit={handleTemplateEditSubmit}>
                        {selectedItem && (
                          <Grid container spacing={1}>
                            <Grid item xs={12}>
                              <TextField label="Template Name" name="name" fullWidth required value={selectedItem.name || ""} onChange={handleInputModChange} sx={{ marginTop: "5px" }} />
                              <TextField name="id" value={selectedItem.id || ""} sx={{ display: "none!important" }} />
                            </Grid>
                            <Grid item xs={12}><TextField multiline rows={3} label="Template Content" fullWidth name="content" value={selectedItem.content || ""} onChange={handleInputModChange} sx={{ marginTop: "5px" }} /></Grid>
                            <Grid item xs={6}><Button type="submit" variant="contained" color='info' sx={{ padding: "10px", marginTop: "10px", width: "100%" }}>Edit Template</Button></Grid>
                            <Grid item xs={6}><Button type="button" variant="contained" color='error' sx={{ padding: "10px", marginTop: "10px", width: "100%" }} onClick={() => handleTemplateDelete(selectedItem.id)}>Delete Template</Button></Grid>
                          </Grid>
                        )}
                      </form>
                    </Box>
                  </Modal>
                </>
              )}
              {activeMini2Tab === 3 && (
                <>
                  <Box sx={{ display: 'flex', justifyContent: 'flex-end', p: 2 }}>
                    <Button variant="contained" sx={{ ml: 2 }} color='primary' onClick={handleOpenBulkContactModal}>Upload Campaign Contacts</Button>
                  </Box>
                  <TableContainer>
                    <Table sx={{ fontSize: '5.1rem !important' }} size="small">
                      <TableHead sx={{ bgcolor: 'background.table', width: '100%' }}>
                        <TableRow><TableCell>Name</TableCell><TableCell>Added</TableCell><TableCell>Date</TableCell><TableCell>Action</TableCell></TableRow>
                      </TableHead>
                      <TableBody>
                        {contactCampaignData.map((row, index) => (
                          <TableRow key={index}>
                            <TableCell>{row.campaign_name}</TableCell><TableCell>{row.added_by}</TableCell><TableCell>{row.date}</TableCell>
                            <TableCell>
                              <Button variant="contained" color="primary" sx={{ padding: '1px', margin: '5px' }} onClick={() => handleOpenContactModal(row.campaign_id, row.campaign_name)}><RecentActors sx={{ fontSize: '1.5rem', cursor: 'pointer', margin: '5px' }} /></Button>
                              <Button variant="contained" color="info" sx={{ padding: '1px', margin: '5px' }} onClick={() => handleOpenContactMessageModal(row)}><Message sx={{ fontSize: '1.5rem', cursor: 'pointer', margin: '5px' }} /></Button>
                              <Button variant="contained" color="error" sx={{ padding: '1px', margin: '5px' }} onClick={() => handleOpenDeleteContactConfirmModal(row)}><DeleteForever sx={{ fontSize: '1.5rem', cursor: 'pointer', margin: '5px' }} /></Button>
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                  <TablePagination component="div" count={totalContactCampaignItems} page={campaignpage} onPageChange={handleCampaignChangePage} rowsPerPage={campaignrowsPerPage} onRowsPerPageChange={handleCampaignChangeRowsPerPage} rowsPerPageOptions={[10, 50, 100]} />
                  <Modal open={openBulkContactModal} onClose={handleCloseBulkContactModal} BackdropProps={{ onClick: (event) => event.stopPropagation() }}>
                    <Box sx={modalStyle}>
                      <Box sx={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                        <h3>Add Campaign Contacts</h3>
                        <h3><Button variant="contained" sx={{ marginTop: "-10px!important" }} onClick={downloadTemplate}>Download Template</Button></h3>
                        <Cancel onClick={handleCloseBulkContactModal} sx={{ cursor: 'pointer' }} />
                      </Box>
                      <form onSubmit={handleBulkContactSubmit}>
                        <Grid container spacing={1}>
                          <Grid item xs={12}><TextField label="Campaign Name" fullWidth required value={campaignName} onChange={(e) => setCampaignName(e.target.value)} sx={{ marginTop: "5px" }} /></Grid>
                          <Grid item xs={12}><TextField name="file" type="file" onChange={handleFileChange} fullWidth sx={{ marginTop: "10px" }} required accept=".csv, .xlsx" /></Grid>
                          <Grid item xs={12}><Button type="submit" variant="contained" color="info" disabled={enableDisableButton} sx={{ padding: "10px", marginTop: "10px", color: 'white' }}>{uploadButtonStatus}</Button></Grid>
                        </Grid>
                      </form>
                    </Box>
                  </Modal>
                  <Modal open={contactConfirmModal} onClose={handleCloseDeleteContactConfirmModal}>
                    <Box sx={modalStyle}>
                      <Box sx={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                        <h3>Delete {selectedItem && selectedItem.campaign_name} and Its Contacts</h3>
                        <Cancel onClick={handleCloseDeleteContactConfirmModal} sx={{ cursor: 'pointer' }} />
                      </Box>
                      <Box justifyContent="center" textAlign="center">
                        <h3><WarningAmber sx={{ fontSize: '70px', color: 'red' }} /><br />Are You Sure? This action is irreversible.</h3>
                      </Box>
                      {selectedItem && (
                        <Grid item xs={12} display="flex" justifyContent="space-between">
                          <Button variant="contained" sx={{ padding: "10px", marginTop: "10px", color: 'white' }} onClick={handleCloseDeleteContactConfirmModal}>No</Button>
                          {sessionStorage.getItem("user_level") !== "agent" && (
                            <Button variant="contained" sx={{ padding: "10px", marginTop: "10px", color: 'white', backgroundColor: 'red' }} onClick={() => handleDeleteCampaignContacts(selectedItem.campaign_id)}>Delete</Button>
                          )}
                        </Grid>
                      )}
                    </Box>
                  </Modal>
                  <Modal open={contactMessageModal} onClose={handleCloseContactMessageModal} BackdropProps={{ onClick: (event) => event.stopPropagation() }}>
                    <Box sx={modalStyle}>
                      <Box sx={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                        <h3>{selectedItem && selectedItem.campaign_name}</h3>
                        <Cancel onClick={handleCloseContactMessageModal} sx={{ cursor: 'pointer' }} />
                      </Box>
                      <form onSubmit={handleCampaignMessageUpdate}>
                        <Grid container spacing={1}>
                          {selectedItem && (
                            <Grid item xs={12}>
                              <TextField multiline label="Campaign Message" fullWidth required name="message" rows={5} value={selectedItem.message || ""} onChange={handleInputModChange} sx={{ marginTop: "5px" }} />
                              <TextField required name="campaign_id" value={selectedItem.campaign_id || ""} onChange={handleInputModChange} sx={{ display: 'none!important' }} />
                            </Grid>
                          )}
                          <Grid item xs={12}><Button type="submit" variant="contained" color="info" sx={{ padding: "10px", marginTop: "10px", color: 'white' }}>Update</Button></Grid>
                        </Grid>
                      </form>
                    </Box>
                  </Modal>
                  <Modal open={contactModal} onClose={handleCloseContactModal} BackdropProps={{ onClick: (event) => event.stopPropagation() }}>
                    <Box sx={modalStyleLarge}>
                      <Box sx={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                        <h3>{tableCampaignName} - Campaign Contacts</h3>
                        <Cancel onClick={handleCloseContactModal} sx={{ cursor: 'pointer' }} />
                      </Box>
                      <TableContainer>
                        <Table sx={{ fontSize: '5.1rem !important' }} size="small">
                          <TableHead sx={{ bgcolor: 'background.table', width: '100%' }}>
                            <TableRow><TableCell>Name</TableCell><TableCell>Contact</TableCell><TableCell>Date</TableCell><TableCell>Action</TableCell></TableRow>
                          </TableHead>
                          <TableBody>
                            {campaignData.map((row, index) => (
                              <TableRow key={index}>
                                <TableCell>{row.name}</TableCell><TableCell>{row.contact}</TableCell><TableCell>{row.date}</TableCell>
                                <TableCell><Button variant="contained" color="error" sx={{ padding: '1px', margin: '5px' }} onClick={() => handleDeleteCampaignContact(row.id, row.campaign_id)}><DeleteForever sx={{ fontSize: '1.5rem', cursor: 'pointer', margin: '5px' }} /></Button></TableCell>
                              </TableRow>
                            ))}
                          </TableBody>
                        </Table>
                      </TableContainer>
                      <TablePagination component="div" count={totalCampaignContactItems} page={campaignContactpage} onPageChange={handleCampaignContactChangePage} rowsPerPage={campaignContactrowsPerPage} onRowsPerPageChange={handleCampaignContactChangeRowsPerPage} rowsPerPageOptions={[5]} />
                    </Box>
                  </Modal>
                </>
              )}
              {activeMini2Tab === 4 && (
                <>
                  <Box sx={{ display: 'flex', justifyContent: 'flex-end', p: 2 }}>
                    <Button variant="contained" sx={{ ml: 2 }} color='success' onClick={handleOpenScheduleModal}>Add Schedule</Button>
                  </Box>
                  <TableContainer>
                    <Table sx={{ fontSize: '5.1rem !important' }} size="small">
                      <TableHead sx={{ bgcolor: 'background.table', width: '100%' }}>
                        <TableRow><TableCell>Name</TableCell><TableCell>Campaign</TableCell><TableCell>Scheduled</TableCell><TableCell>Status</TableCell><TableCell>Date</TableCell><TableCell>Action</TableCell></TableRow>
                      </TableHead>
                      <TableBody>
                        {scheduledData.length > 0 ? scheduledData.map((row) => (
                          <TableRow key={row.id}>
                            <TableCell>{row.schedule_name}</TableCell><TableCell>{row.campaign_name}</TableCell><TableCell>{row.schedule_time}</TableCell>
                            <TableCell sx={{ color: row.status === 'sent' ? 'green !important' : '', fontWeight: 'bold' }}>{row.status}</TableCell>
                            <TableCell>{row.date}</TableCell>
                            <TableCell><Button disabled={row.status === 'sent'} variant="contained" color="info" sx={{ padding: '1px', margin: '5px' }} onClick={() => handleOpenEditScheduleModal(row)}><RemoveRedEye sx={{ fontSize: '1.5rem', cursor: 'pointer', margin: '5px' }} /></Button></TableCell>
                          </TableRow>
                        )) : (<TableRow><TableCell colSpan={7} align="center">No Records Found</TableCell></TableRow>)}
                      </TableBody>
                    </Table>
                  </TableContainer>
                  <TablePagination component="div" count={totalScheduled} page={schedulepage} onPageChange={handleScheduleChangePage} rowsPerPage={schedulerowsPerPage} onRowsPerPageChange={handleScheduleChangeRowsPerPage} rowsPerPageOptions={[10, 50, 100]} />
                </>
              )}
            </Box>
          </Grid>
        </Grid>
      )}
      
      {/* ═══════════════════════════════════════════════════════ */}
      {/* TAB 1 — WHATSAPP (unchanged)                            */}
      {/* ═══════════════════════════════════════════════════════ */}
      {activeTab === 1 && (
        <Grid container spacing={0}>
          <Grid item xs={3} md={3}>
            <Box sx={{ height: '77vh', bgcolor: 'background.paper', boxShadow: 'none', border: '0.1px solid rgba(207, 211, 212, 0.2)', borderRadius: '5px 0px 0px 5px', padding: '10px' }}>
              <Grid container spacing={1} sx={{ marginBottom: '10px' }}>
                <Grid item xs={4}><Button variant='outlined' fullWidth color='success' sx={{ fontWeight: 'bold' }} onClick={handleOpenAddChatModal}>Chat</Button></Grid>
                <Grid item xs={4}>
                  <FormControl variant="outlined" sx={{ width: '100%', '& .MuiOutlinedInput-root': { height: '33px' }, '& .MuiInputLabel-root': { top: '-8px' } }}>
                    <InputLabel>FILTER</InputLabel>
                    <Select label="Filter" value=''>
                      <MenuItem value="all">None</MenuItem>
                      <MenuItem value="unread">Unread</MenuItem>
                      <MenuItem value="contact">Contact</MenuItem>
                      <MenuItem value="non_contact">Non-Contact</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={4}><Button variant='outlined' fullWidth color='info' sx={{ fontWeight: 'bold' }}>Template</Button></Grid>
              </Grid>
              <TextField fullWidth label="Search Contacts" name="search" onChange={handleSearchChange} value={searchWhatsAppTerm} />
              <Box sx={{ height: '57vh', overflowY: 'auto', marginTop: '10px', marginBottom: '10px', padding: '0 10px 10px 0' }}>
                {whatsAppContacts.map((contact) => (
                  <Grid key={contact.id} container sx={{ cursor: 'pointer', bgcolor: contactSetRef.current === contact.contact_number ? 'action.hover' : '', padding: '6px', borderRadius: '5px', marginTop: '10px' }} onClick={() => handleFetchWhatsAppMessages(contact, contact.contact_number)}>
                    <Grid item xs={2}><Person sx={{ fontSize: '26px', marginLeft: '10px' }} /></Grid>
                    <Grid item xs={9}>
                      <Box sx={{ marginTop: '5px' }}>{contact.contact_name || contact.contact_number}</Box>
                      <Box sx={{ fontSize: '0.85rem', color: 'text.secondary' }}>{contact.lastMessage ? `${contact.lastMessage.slice(0, 20)}... · ${new Date(contact.time).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}` : ''}</Box>
                    </Grid>
                    <Grid item xs={1}>
                      {contact.unreadCount > 0 && (<Box sx={{ textAlign: 'center', height: '21px', width: '21px', background: 'primary.main', color: 'white', borderRadius: '50%' }}>{contact.unreadCount}</Box>)}
                    </Grid>
                  </Grid>
                ))}
              </Box>
            </Box>
          </Grid>
          <Grid item xs={6} md={6}>
            <Box sx={{ bgcolor: 'background.paper', boxShadow: 'none', border: '0.1px solid rgba(207, 211, 212, 0.2)', padding: '10px', height: '100%' }}>
              <Grid container sx={{ marginBottom: '10px' }} justifyContent="space-between" alignItems="center">
                <Grid item><Typography variant="h6">{selectedContact ? (selectedContact.contact_name ? selectedContact.contact_name : selectedContact.contact_number) : 'Select a contact'}</Typography></Grid>
                <Grid item>{contactSetRef.current && <Button variant="outlined" color="success" sx={{ fontWeight: 'bold' }} onClick={() => copyPhoneNumber(selectedContact.contact_number)}><Phone /></Button>}</Grid>
              </Grid>
              <Box sx={{ p: '10px', borderRadius: '5px', height: '58vh', overflowY: 'auto', marginTop: '10px', marginBottom: '10px' }}>
                {whatsAppMessagesData.map((msg, idx) => (
                  <Box key={idx} sx={{ display: 'flex', justifyContent: msg.origin === 'outbound' ? 'flex-end' : 'flex-start', mb: 2 }} ref={idx === whatsAppMessagesData.length - 1 ? messagesEndRef : null}>
                    <Box sx={{ backgroundColor: msg.origin === 'outbound' ? 'background.chatsender' : 'background.chatrecipient', color: 'inherit', borderRadius: msg.origin === 'outbound' ? '10px 10px 0px 10px' : '10px 10px 10px 0px', p: 1, maxWidth: '60%' }}>
                      {msg.text_body}
                      <Box sx={{ display: 'flex', justifyContent: 'space-between', fontSize: '0.7rem', mt: 1 }}>
                        <Box mr={1}>{formatMessageDate(msg.date)}</Box>
                        <Box>{new Date(msg.date).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}</Box>
                      </Box>
                    </Box>
                  </Box>
                ))}
              </Box>
              {contactSetRef.current && (
                <form onSubmit={handleSendMessage}>
                  <Grid container spacing={0}>
                    <Grid item xs={11}>
                      <TextField multiline rows={1} label="Type a message" fullWidth value={newMessage} onChange={(event) => setNewMessage(event.target.value)} onKeyDown={handleKeyPress} sx={{ '& .MuiOutlinedInput-root': { '& fieldset': { borderRight: 'none' }, borderRadius: 2, borderTopRightRadius: 0, borderBottomRightRadius: 0 } }} />
                    </Grid>
                    <Grid item xs={1}>
                      <Button type="submit" variant="contained" sx={{ width: '100%', height: '100%', marginLeft: '-15px', borderRadius: '0px 20px 20px 0px' }} disabled={!newMessage}><Send /></Button>
                    </Grid>
                  </Grid>
                </form>
              )}
            </Box>
          </Grid>
          <Modal open={openAddChatModal} onClose={handleCloseAddChatModal}>
            <Box sx={modalStyle}>
              <Box sx={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                <h3>New Chat</h3><Cancel onClick={handleCloseAddChatModal} sx={{ cursor: 'pointer' }} />
              </Box>
              <Box sx={{ padding: 2, display: 'flex', gap: 2 }}>
                <TextField label="Search" variant="outlined" value={searchContactTerm} onChange={handleSearchContactChange} placeholder="Search" fullWidth />
              </Box>
              <TableContainer>
                <Table sx={{ fontSize: '5.1rem !important' }} size="small">
                  <TableHead sx={{ bgcolor: 'background.table', width: '100%' }}>
                    <TableRow><TableCell>Name</TableCell><TableCell>Phone Number</TableCell></TableRow>
                  </TableHead>
                  <TableBody>
                    {contactData.length > 0 ? contactData.map((row) => (
                      <TableRow key={row.id} onClick={() => handleFetchWhatsAppContactMessages(row.name, row.phone_number)} sx={{ cursor: 'pointer', '&:hover': { backgroundColor: 'action.hover', borderRadius: '30px' } }}>
                        <TableCell sx={{ p: 2 }}>{row.name}</TableCell><TableCell>{row.phone_number}</TableCell>
                      </TableRow>
                    )) : (<TableRow><TableCell colSpan={6} align="center">No matching records found</TableCell></TableRow>)}
                  </TableBody>
                </Table>
              </TableContainer>
              <TablePagination component="div" count={totalContactItems} page={contactpage} onPageChange={handleContactChangePage} rowsPerPage={rowsPerPage} onRowsPerPageChange={handleContactChangeRowsPerPage} rowsPerPageOptions={[10, 50, 100]} labelRowsPerPage="Rows per page" />
            </Box>
          </Modal>
          <Grid item xs={3} md={3}>
            <Box sx={{ height: '77vh', bgcolor: 'background.paper', boxShadow: 'none', border: '0.1px solid rgba(207, 211, 212, 0.2)', borderRadius: '0px 5px 5px 0px', padding: '10px', overflowY: 'auto' }}>
              <Typography variant="h6">Contact Information</Typography>
              {selectedContact && (
                <>
                  <Typography variant="body1"><strong>Name:</strong> {selectedContact.contact_name || ''}</Typography>
                  <Typography variant="body1"><strong>Phone:</strong> {selectedContact.contact_number || ''}</Typography>
                  <Typography variant="body1"><strong>Last Active:</strong> {`${formatMessageDate(selectedContact.last_message_date)}`} {`, ${new Date(selectedContact.last_message_date).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}`}</Typography>
                </>
              )}
              <Divider sx={{ marginTop: '10px', marginBottom: '10px' }} />
              <Typography variant="h6">Ticketing Information</Typography>
              <Divider sx={{ marginTop: '10px', marginBottom: '10px' }} />
              <Typography variant="h6">Disposition Information</Typography>
            </Box>
          </Grid>
        </Grid>
      )}
      
      {/* ═══════════════════════════════════════════════════════ */}
      {/* TAB 2 — WEBCHAT (Refactored)                            */}
      {/* ═══════════════════════════════════════════════════════ */}
      {activeTab === 2 && (
        <Grid container spacing={0}>
          {/* Left: Chat Queue (Now includes Inline Archived Section) */}
          <Grid item xs={3}>
            <Box sx={{ height: '77vh', bgcolor: 'background.paper', border: '0.1px solid rgba(207, 211, 212, 0.2)', borderRadius: '5px 0 0 5px', padding: '10px', display: 'flex', flexDirection: 'column' }}>
              <Typography variant="h6" sx={{ mb: 1 }}>Webchat Queue</Typography>
              <TextField fullWidth size="small" label="Search" value={searchWebchatTerm} onChange={(e) => setSearchWebchatTerm(e.target.value)} sx={{ mb: 1 }} />
              
              {/* Active Chats Section */}
              <Typography variant="caption" sx={{ mt: 0.5, mb: 0.5, fontWeight: 'bold', color: 'text.primary', px: 0.5 }}>Active Chats</Typography>
              <Box sx={{ flexGrow: 1, overflowY: 'auto' }}>
                {webchatQueues.length === 0 ? (
                  <Typography variant="body2" color="text.secondary" sx={{ mt: 2, textAlign: 'center' }}>No active chats</Typography>
                ) : webchatQueues.map((chat) => (
                  <Box
                    key={chat.session_id}
                    onClick={() => handleSelectWebchat(chat)}
                    sx={{ cursor: 'pointer', padding: '8px', borderRadius: '5px', marginTop: '8px', bgcolor: webchatContactRef.current === chat.session_id ? 'action.hover' : '', '&:hover': { bgcolor: 'action.hover' } }}
                  >
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                      <Chat sx={{ fontSize: '20px' }} />
                      <Box sx={{ flexGrow: 1 }}>
                        <Typography variant="body2" fontWeight="bold">{chat.visitor_name || 'Visitor'}</Typography>
                        <Typography variant="caption" color="text.secondary">{chat.last_message ? `${chat.last_message.slice(0, 25)}...` : 'New chat'}</Typography>
                      </Box>
                      {chat.unread_count > 0 && (<Box sx={{ minWidth: '20px', height: '20px', bgcolor: 'primary.main', color: 'white', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '0.7rem' }}>{chat.unread_count}</Box>)}
                    </Box>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, mt: 0.5 }}>
                      <Circle sx={{ fontSize: '8px', color: chat.status === 'active' ? 'success.main' : 'warning.main' }} />
                      <Typography variant="caption" color="text.secondary">{chat.page_url || ''}</Typography>
                    </Box>
                  </Box>
                ))}
              </Box>

              {/* Divider & Toggle Button */}
              <Divider sx={{ my: 1 }} />
              <Button 
                variant="outlined" 
                size="small" 
                fullWidth
                startIcon={showArchivedQueue ? <Close sx={{fontSize: 16}} /> : <History />}
                onClick={() => {
                  setShowArchivedQueue(prev => !prev);
                  if (!showArchivedQueue && archivedWebchatSessions.length === 0) {
                    fetchArchivedWebchatSessions();
                  }
                }}
                sx={{ mb: showArchivedQueue ? 1 : 0 }}
              >
                {showArchivedQueue ? 'Hide Archived' : 'Show Archived'}
              </Button>

              {/* Archived Chats Section (Inline) */}
              {showArchivedQueue && (
                <Box sx={{ maxHeight: '40%', overflowY: 'auto', borderTop: '1px solid', borderColor: 'divider', pt: 1, display: 'flex', flexDirection: 'column' }}>
                  <Box sx={{ px: 0.5 }}>
                    <Typography variant="caption" sx={{ fontWeight: 'bold', color: 'text.primary', display: 'block', mb: 0.5 }}>Archived Chats</Typography>
                    <TextField fullWidth size="small" placeholder="Search archived..." value={archivedSearchTerm} onChange={(e) => { setArchivedSearchTerm(e.target.value); setArchivedPage(0); }} sx={{ mb: 1 }} />
                  </Box>
                  <Box sx={{ flexGrow: 1, overflowY: 'auto', px: 0.5 }}>
                    {archivedLoading ? (
                      <Typography variant="body2" color="text.secondary" sx={{ p: 2, textAlign: 'center' }}>Loading...</Typography>
                    ) : archivedWebchatSessions.length === 0 ? (
                      <Typography variant="body2" color="text.secondary" sx={{ p: 2, textAlign: 'center' }}>No archived chats</Typography>
                    ) : archivedWebchatSessions.map((chat) => (
                      <Box
                        key={chat.session_id}
                        onClick={() => handleSelectArchivedChat(chat)}
                        sx={{
                          cursor: 'pointer', p: 1, mb: 0.5, borderRadius: 1,
                          bgcolor: selectedArchivedChat?.session_id === chat.session_id ? 'action.selected' : 'transparent',
                          border: '1px solid', borderColor: 'divider', '&:hover': { bgcolor: 'action.hover' }
                        }}
                      >
                        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                          <Box sx={{ flexGrow: 1 }}>
                            <Typography variant="body2" fontWeight="bold">{chat.visitor_name || 'Visitor'}</Typography>
                            <Typography variant="caption" color="text.secondary" display="block">{chat.visitor_email || chat.visitor_phone || 'No contact'}</Typography>
                            <Typography variant="caption" color="text.secondary" display="block">Ended: {chat.ended_at ? new Date(chat.ended_at).toLocaleDateString() : 'Unknown'}</Typography>
                            {chat.last_message && (<Typography variant="caption" color="text.secondary" sx={{ mt: 0.3, display: 'block', fontStyle: 'italic' }}>{chat.last_message.slice(0, 35)}...</Typography>)}
                          </Box>
                          <Chip label={chat.status || 'ended'} size="small" color="default" sx={{ fontSize: '0.6rem', height: '18px' }} />
                        </Box>
                      </Box>
                    ))}
                  </Box>
                  <TablePagination
                    component="div" count={totalArchivedItems} page={archivedPage}
                    onPageChange={(e, newPage) => setArchivedPage(newPage)}
                    rowsPerPage={archivedRowsPerPage}
                    onRowsPerPageChange={(e) => { setArchivedRowsPerPage(parseInt(e.target.value, 10)); setArchivedPage(0); }}
                    rowsPerPageOptions={[5, 10, 25]}
                    size="small"
                    sx={{ borderTop: '1px solid', borderColor: 'divider', mt: 'auto' }}
                  />
                </Box>
              )}
            </Box>
          </Grid>

          {/* Middle: Chat Window (Supports Active & Archived) */}
          <Grid item xs={6}>
            <Box sx={{ bgcolor: 'background.paper', border: '0.1px solid rgba(207, 211, 212, 0.2)', padding: '10px', height: '77vh', display: 'flex', flexDirection: 'column' }}>
              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
                <Typography variant="h6">
                  {selectedWebchat ? selectedWebchat.visitor_name : selectedArchivedChat ? selectedArchivedChat.visitor_name : 'Select a chat'}
                </Typography>
                {selectedWebchat && (
                  <Box sx={{ display: 'flex', gap: 1 }}>
                    {selectedWebchat.visitor_phone && (
                      <Button variant="outlined" color="success" size="small" onClick={() => copyPhoneNumber(selectedWebchat.visitor_phone, '')}><Phone /></Button>
                    )}
                    <Button variant="outlined" color="error" size="small" onClick={() => handleEndWebchat(selectedWebchat.session_id)}>End Chat</Button>
                  </Box>
                )}
                {selectedArchivedChat && (
                  <Chip label="Archived" color="default" size="small" icon={<Archive />} sx={{ ml: 1 }} />
                )}
              </Box>
              <Box sx={{ flexGrow: 1, overflowY: 'auto', p: '10px', borderRadius: '5px' }}>
                {selectedWebchat || selectedArchivedChat ? (
                  (selectedArchivedChat ? archivedMessages : webchatMessages).map((msg, idx) => (
                    <Box key={idx} sx={{ display: 'flex', justifyContent: msg.origin === 'outbound' ? 'flex-end' : 'flex-start', mb: 2 }}
                      ref={idx === (selectedArchivedChat ? archivedMessages : webchatMessages).length - 1 ? (selectedArchivedChat ? archivedMessagesEndRef : webchatMessagesEndRef) : null}>
                      <Box sx={{ backgroundColor: msg.origin === 'outbound' ? 'background.chatsender' : 'background.chatrecipient', borderRadius: msg.origin === 'outbound' ? '10px 10px 0px 10px' : '10px 10px 10px 0px', p: 1, maxWidth: '60%' }}>
                        {msg.message}
                        <Box sx={{ display: 'flex', justifyContent: 'flex-end', fontSize: '0.7rem', mt: 0.5, color: 'text.secondary' }}>
                          {new Date(msg.date).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
                        </Box>
                      </Box>
                    </Box>
                  ))
                ) : (
                  <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%' }}>
                    <Typography variant="body1" color="text.secondary">Select a conversation</Typography>
                  </Box>
                )}
              </Box>
              {selectedWebchat ? (
                <form onSubmit={handleSendWebchatMessage}>
                  <Grid container spacing={0}>
                    <Grid item xs={11}>
                      <TextField multiline rows={1} label="Type a message" fullWidth value={newWebchatMessage} onChange={(e) => setNewWebchatMessage(e.target.value)} onKeyDown={handleWebchatKeyPress}
                        sx={{ '& .MuiOutlinedInput-root': { '& fieldset': { borderRight: 'none' }, borderRadius: 2, borderTopRightRadius: 0, borderBottomRightRadius: 0 } }} />
                    </Grid>
                    <Grid item xs={1}>
                      <Button type="submit" variant="contained" sx={{ width: '100%', height: '100%', marginLeft: '-15px', borderRadius: '0px 20px 20px 0px' }} disabled={!newWebchatMessage}><Send /></Button>
                    </Grid>
                  </Grid>
                </form>
              ) : selectedArchivedChat ? (
                <Box sx={{ p: 2, borderTop: '1px solid', borderColor: 'divider', textAlign: 'center', bgcolor: 'action.hover' }}>
                  <Typography variant="caption" color="text.secondary">
                    <Archive sx={{ fontSize: '0.9rem', verticalAlign: 'middle', mr: 0.5 }} />
                    This chat has ended and is read-only
                  </Typography>
                </Box>
              ) : null}
            </Box>
          </Grid>

          {/* Right: Visitor Info */}
          <Grid item xs={3}>
            <Box sx={{ height: '77vh', bgcolor: 'background.paper', border: '0.1px solid rgba(207, 211, 212, 0.2)', borderRadius: '0 5px 5px 0', padding: '10px', overflowY: 'auto' }}>
              <Typography variant="h6">Visitor Information</Typography>
              {(selectedWebchat || selectedArchivedChat) ? (
                <>
                  <Typography variant="body2" sx={{ mt: 1 }}><strong>Name:</strong> {(selectedWebchat || selectedArchivedChat).visitor_name || 'Unknown'}</Typography>
                  <Typography variant="body2"><strong>Email:</strong> {(selectedWebchat || selectedArchivedChat).visitor_email || '—'}</Typography>
                  <Typography variant="body2"><strong>Phone:</strong> {(selectedWebchat || selectedArchivedChat).visitor_phone || '—'}</Typography>
                  <Divider sx={{ my: 1 }} />
                  <Typography variant="h6">Session Info</Typography>
                  <Typography variant="body2"><strong>Page:</strong> {(selectedWebchat || selectedArchivedChat).page_url || '—'}</Typography>
                  <Typography variant="body2"><strong>Status:</strong> {selectedArchivedChat ? 'Ended' : (selectedWebchat?.status || '—')}</Typography>
                  <Typography variant="body2"><strong>Ended:</strong> {selectedArchivedChat?.ended_at ? new Date(selectedArchivedChat.ended_at).toLocaleString() : 'Active'}</Typography>
                </>
              ) : (
                <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>No chat selected</Typography>
              )}
              <Divider sx={{ my: 1 }} />
              <Typography variant="h6">Disposition</Typography>
            </Box>
          </Grid>
        </Grid>
      )}
      
      {/* ═══════════════════════════════════════════════════════ */}
      {/* TAB 3 — MS DYNAMICS (unchanged)                         */}
      {/* ═══════════════════════════════════════════════════════ */}
      {activeTab === 3 && (
        <Grid container spacing={2}>
          <Grid item xs={4}>
            <Box sx={{ bgcolor: 'background.paper', border: '0.1px solid rgba(207, 211, 212, 0.2)', borderRadius: '5px', padding: '10px', height: '77vh', display: 'flex', flexDirection: 'column' }}>
              <Typography variant="h6" sx={{ mb: 1 }}>Contact Lookup</Typography>
              <Box sx={{ display: 'flex', gap: 1, mb: 2 }}>
                <TextField fullWidth size="small" label="Search by name or phone" value={dynamicsSearch} onChange={(e) => setDynamicsSearch(e.target.value)} onKeyDown={(e) => { if (e.key === 'Enter') handleDynamicsSearch(); }} />
                <Button variant="contained" onClick={handleDynamicsSearch} disabled={dynamicsLoading}><Search /></Button>
              </Box>
              <Box sx={{ flexGrow: 1, overflowY: 'auto' }}>
                {dynamicsSearchResults.map((contact) => (
                  <Box key={contact.id} onClick={() => handleSelectDynamicsContact(contact)} sx={{ cursor: 'pointer', padding: '8px', borderRadius: '5px', mb: 1, border: '0.1px solid rgba(207, 211, 212, 0.3)', bgcolor: dynamicsContact?.id === contact.id ? 'action.hover' : '', '&:hover': { bgcolor: 'action.hover' } }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                      <Business sx={{ fontSize: '20px', color: 'text.secondary' }} />
                      <Box>
                        <Typography variant="body2" fontWeight="bold">{contact.fullname}</Typography>
                        <Typography variant="caption" color="text.secondary">{contact.jobtitle || ''} {contact.company ? `· ${contact.company}` : ''}</Typography>
                        <Typography variant="caption" display="block" color="text.secondary">{contact.phone || contact.mobilephone || ''}</Typography>
                      </Box>
                    </Box>
                  </Box>
                ))}
                {dynamicsSearchResults.length === 0 && !dynamicsLoading && (<Typography variant="body2" color="text.secondary" sx={{ textAlign: 'center', mt: 2 }}>Search for a contact above</Typography>)}
              </Box>
            </Box>
          </Grid>
          <Grid item xs={8}>
            <Box sx={{ bgcolor: 'background.paper', border: '0.1px solid rgba(207, 211, 212, 0.2)', borderRadius: '5px', padding: '10px', height: '77vh', display: 'flex', flexDirection: 'column' }}>
              {dynamicsContact ? (
                <>
                  <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: 2 }}>
                    <Box>
                      <Typography variant="h5">{dynamicsContact.fullname}</Typography>
                      <Typography variant="body2" color="text.secondary">{dynamicsContact.jobtitle} {dynamicsContact.company ? `· ${dynamicsContact.company}` : ''}</Typography>
                      <Box sx={{ display: 'flex', gap: 2, mt: 1 }}>
                        {dynamicsContact.phone && <Typography variant="body2"><strong>Phone:</strong> {dynamicsContact.phone}</Typography>}
                        {dynamicsContact.email && <Typography variant="body2"><strong>Email:</strong> {dynamicsContact.email}</Typography>}
                      </Box>
                    </Box>
                    <Box sx={{ display: 'flex', gap: 1 }}>
                      {dynamicsContact.phone && (<Button variant="outlined" color="success" size="small" onClick={() => copyPhoneNumber(dynamicsContact.phone, '')}><Phone /></Button>)}
                      <Button variant="outlined" color="primary" size="small" startIcon={<Note />} onClick={() => setAddNoteModal(true)}>Add Note</Button>
                    </Box>
                  </Box>
                  <Divider sx={{ mb: 2 }} />
                  <Typography variant="h6" sx={{ mb: 1 }}>Activity Timeline</Typography>
                  <Box sx={{ flexGrow: 1, overflowY: 'auto' }}>
                    {dynamicsActivities.length === 0 ? (<Typography variant="body2" color="text.secondary">No activities found</Typography>) : dynamicsActivities.map((activity, idx) => (
                      <Box key={idx} sx={{ display: 'flex', gap: 1.5, mb: 2, alignItems: 'flex-start' }}>
                        <Box sx={{ mt: 0.5 }}>
                          {activity.type === 'call' ? <Phone sx={{ fontSize: '16px', color: 'success.main' }} /> : activity.type === 'note' ? <Note sx={{ fontSize: '16px', color: 'info.main' }} /> : <AccessTime sx={{ fontSize: '16px', color: 'text.secondary' }} />}
                        </Box>
                        <Box sx={{ flexGrow: 1, border: '0.1px solid rgba(207, 211, 212, 0.3)', borderRadius: '5px', p: 1 }}>
                          <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                            <Typography variant="body2" fontWeight="bold">{activity.subject || activity.type}</Typography>
                            <Typography variant="caption" color="text.secondary">{activity.date ? new Date(activity.date).toLocaleDateString() : ''}</Typography>
                          </Box>
                          {activity.description && <Typography variant="body2" color="text.secondary">{activity.description}</Typography>}
                          {activity.agent && <Typography variant="caption" color="text.secondary">By: {activity.agent}</Typography>}
                        </Box>
                      </Box>
                    ))}
                  </Box>
                </>
              ) : (<Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%' }}><Typography variant="body1" color="text.secondary">Select a contact to view details</Typography></Box>)}
            </Box>
          </Grid>
          <Modal open={addNoteModal} onClose={() => setAddNoteModal(false)}>
            <Box sx={modalStyle}>
              <Box sx={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                <h3>Add Note — {dynamicsContact?.fullname}</h3>
                <Cancel onClick={() => setAddNoteModal(false)} sx={{ cursor: 'pointer' }} />
              </Box>
              <Grid container spacing={1}>
                <Grid item xs={12}><TextField multiline rows={5} fullWidth label="Note" value={noteContent} onChange={(e) => setNoteContent(e.target.value)} sx={{ mt: 1 }} /></Grid>
                <Grid item xs={12}><Button variant="contained" fullWidth onClick={handleAddDynamicsNote} disabled={!noteContent.trim()}>Save Note</Button></Grid>
              </Grid>
            </Box>
          </Modal>
        </Grid>
      )}
      
      {/* ═══════════════════════════════════════════════════════ */}
      {/* TAB 4 — SOCIALS (unchanged)                             */}
      {/* ═══════════════════════════════════════════════════════ */}
      {activeTab === 4 && (
        <Grid container spacing={0}>
          <Grid item xs={3}>
            <Box sx={{ height: '77vh', bgcolor: 'background.paper', border: '0.1px solid rgba(207, 211, 212, 0.2)', borderRadius: '5px 0 0 5px', padding: '10px', display: 'flex', flexDirection: 'column' }}>
              <Typography variant="h6" sx={{ mb: 1 }}>Social Inbox</Typography>
              <Box sx={{ display: 'flex', gap: 0.5, mb: 1, flexWrap: 'wrap' }}>
                {['all', 'facebook', 'instagram', 'twitter'].map((p) => (
                  <Chip key={p} label={p === 'all' ? 'All' : p.charAt(0).toUpperCase() + p.slice(1)} size="small" onClick={() => setSocialFilter(p)} color={socialFilter === p ? 'primary' : 'default'} icon={p !== 'all' ? getPlatformIcon(p) : undefined} sx={{ cursor: 'pointer', textTransform: 'capitalize' }} />
                ))}
              </Box>
              <Box sx={{ display: 'flex', gap: 1, mb: 1 }}>
                <Button variant="outlined" size="small" startIcon={<Refresh />} onClick={() => fetchSocialInbox(socialFilter)} sx={{ flexShrink: 0 }}>Refresh</Button>
              </Box>
              <Box sx={{ flexGrow: 1, overflowY: 'auto' }}>
                {socialLoading ? (<Typography variant="body2" color="text.secondary" sx={{ textAlign: 'center', mt: 2 }}>Loading...</Typography>) : socialInbox.length === 0 ? (<Typography variant="body2" color="text.secondary" sx={{ textAlign: 'center', mt: 2 }}>No messages</Typography>) : socialInbox.map((item) => (
                  <Box key={item.thread_id} onClick={() => handleSelectSocialItem(item)} sx={{ cursor: 'pointer', padding: '8px', borderRadius: '5px', mb: 1, border: `1px solid ${selectedSocialItem?.thread_id === item.thread_id ? getPlatformColor(item.platform) : 'rgba(207, 211, 212, 0.2)'}`, bgcolor: selectedSocialItem?.thread_id === item.thread_id ? 'action.hover' : '', '&:hover': { bgcolor: 'action.hover' } }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '32px', height: '32px', borderRadius: '50%', bgcolor: 'action.hover', flexShrink: 0 }}>{getPlatformIcon(item.platform)}</Box>
                      <Box sx={{ flexGrow: 1, minWidth: 0 }}>
                        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                          <Typography variant="body2" fontWeight="bold" noWrap>{item.sender_name}</Typography>
                          <Typography variant="caption" color="text.secondary" sx={{ flexShrink: 0, ml: 0.5 }}>{item.time ? new Date(item.time).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }) : ''}</Typography>
                        </Box>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                          <Chip label={getSourceTypeLabel(item.source_type)} size="small" sx={{ height: '16px', fontSize: '0.6rem', bgcolor: getPlatformColor(item.platform), color: 'white' }} />
                          <Typography variant="caption" color="text.secondary" noWrap>{item.preview ? `${item.preview.slice(0, 22)}...` : ''}</Typography>
                        </Box>
                      </Box>
                      {item.unread_count > 0 && (<Box sx={{ minWidth: '18px', height: '18px', bgcolor: 'error.main', color: 'white', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '0.65rem', flexShrink: 0 }}>{item.unread_count}</Box>)}
                    </Box>
                  </Box>
                ))}
              </Box>
            </Box>
          </Grid>
          <Grid item xs={6}>
            <Box sx={{ bgcolor: 'background.paper', border: '0.1px solid rgba(207, 211, 212, 0.2)', padding: '10px', height: '77vh', display: 'flex', flexDirection: 'column' }}>
              {selectedSocialItem ? (
                <>
                  <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                      {getPlatformIcon(selectedSocialItem.platform)}
                      <Typography variant="h6">{selectedSocialItem.sender_name}</Typography>
                      <Chip label={getSourceTypeLabel(selectedSocialItem.source_type)} size="small" sx={{ bgcolor: getPlatformColor(selectedSocialItem.platform), color: 'white', fontSize: '0.7rem' }} />
                    </Box>
                    {selectedSocialItem.sender_phone && (<Button variant="outlined" color="success" size="small" onClick={() => copyPhoneNumber(selectedSocialItem.sender_phone, '')}><Phone /></Button>)}
                  </Box>
                  <Divider sx={{ mb: 1 }} />
                  <Box sx={{ flexGrow: 1, overflowY: 'auto', p: '10px' }}>
                    {socialMessages.map((msg, idx) => (
                      <Box key={idx} sx={{ display: 'flex', justifyContent: msg.origin === 'outbound' ? 'flex-end' : 'flex-start', mb: 2 }} ref={idx === socialMessages.length - 1 ? socialMessagesEndRef : null}>
                        <Box sx={{ backgroundColor: msg.origin === 'outbound' ? 'background.chatsender' : 'background.chatrecipient', borderRadius: msg.origin === 'outbound' ? '10px 10px 0px 10px' : '10px 10px 10px 0px', p: 1, maxWidth: '65%' }}>
                          {msg.origin === 'inbound' && (<Typography variant="caption" color="text.secondary" display="block" sx={{ mb: 0.5 }}>{msg.sender_name}</Typography>)}
                          {msg.message}
                          <Box sx={{ display: 'flex', justifyContent: 'flex-end', fontSize: '0.65rem', mt: 0.5, color: 'text.secondary' }}>{new Date(msg.date).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}</Box>
                        </Box>
                      </Box>
                    ))}
                  </Box>
                  <form onSubmit={handleSendSocialReply}>
                    <Grid container spacing={0}>
                      <Grid item xs={11}>
                        <TextField multiline rows={1} label={`Reply via ${selectedSocialItem.platform}`} fullWidth value={newSocialMessage} onChange={(e) => setNewSocialMessage(e.target.value)} onKeyDown={handleSocialKeyPress} sx={{ '& .MuiOutlinedInput-root': { '& fieldset': { borderRight: 'none' }, borderRadius: 2, borderTopRightRadius: 0, borderBottomRightRadius: 0 } }} />
                      </Grid>
                      <Grid item xs={1}>
                        <Button type="submit" variant="contained" sx={{ width: '100%', height: '100%', marginLeft: '-15px', borderRadius: '0px 20px 20px 0px', bgcolor: getPlatformColor(selectedSocialItem.platform) }} disabled={!newSocialMessage}><Send /></Button>
                      </Grid>
                    </Grid>
                  </form>
                </>
              ) : (<Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%' }}><Typography variant="body1" color="text.secondary">Select a conversation from the inbox</Typography></Box>)}
            </Box>
          </Grid>
          <Grid item xs={3}>
            <Box sx={{ height: '77vh', bgcolor: 'background.paper', border: '0.1px solid rgba(207, 211, 212, 0.2)', borderRadius: '0 5px 5px 0', padding: '10px', overflowY: 'auto' }}>
              <Typography variant="h6">Sender Information</Typography>
              {selectedSocialItem ? (
                <>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mt: 1, mb: 1 }}>{getPlatformIcon(selectedSocialItem.platform)}<Typography variant="body2" sx={{ textTransform: 'capitalize' }}>{selectedSocialItem.platform}</Typography></Box>
                  <Typography variant="body2"><strong>Name:</strong> {selectedSocialItem.sender_name || '—'}</Typography>
                  <Typography variant="body2"><strong>Handle:</strong> {selectedSocialItem.sender_handle || '—'}</Typography>
                  <Typography variant="body2"><strong>Type:</strong> {getSourceTypeLabel(selectedSocialItem.source_type)}</Typography>
                  {selectedSocialItem.post_content && (
                    <>
                      <Divider sx={{ my: 1 }} />
                      <Typography variant="h6">Original Post</Typography>
                      <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5, fontStyle: 'italic' }}>{selectedSocialItem.post_content}</Typography>
                    </>
                  )}
                </>
              ) : (<Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>No conversation selected</Typography>)}
              <Divider sx={{ my: 1 }} />
              <Typography variant="h6">Disposition</Typography>
            </Box>
          </Grid>
        </Grid>
      )}
      
      {/* Schedule & Utility Modals (unchanged) */}
      <Modal open={scheduleModal} onClose={handleCloseScheduleModal} BackdropProps={{ onClick: (event) => event.stopPropagation() }}>
        <Box sx={modalStyle}>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}><h3>Add Schedule</h3><Cancel onClick={handleCloseScheduleModal} sx={{ cursor: 'pointer' }} /></Box>
          <form onSubmit={handleSmsScheduleSubmit}>
            <Grid container spacing={1}>
              <Grid item xs={6}><TextField label="Schedule Name" fullWidth required name='schedule_name' sx={{ marginTop: "5px" }} onChange={handleInputChange} /></Grid>
              <Grid item xs={6}>
                <TextField fullWidth select label="Campaign" name="campaign_id" sx={{ marginTop: "5px" }} onChange={handleInputChange}>
                  <MenuItem value="" disabled>Select Campaign</MenuItem>
                  {campaignContactList.map((c, i) => <MenuItem key={i} value={c.campaign_id}>{c.campaign_name}</MenuItem>)}
                </TextField>
              </Grid>
              <Grid item xs={6}><TextField label="Schedule Date & Time" fullWidth name='schedule_time' required onChange={handleInputChange} sx={{ marginTop: "5px" }} type="datetime-local" InputLabelProps={{ shrink: true }} /></Grid>
              <Grid item xs={6}>
                <TextField fullWidth select label="Status" name="status" sx={{ marginTop: "5px" }} onChange={handleInputChange}>
                  <MenuItem value="" disabled>Status</MenuItem>
                  <MenuItem value="scheduled">Schedule</MenuItem>
                  <MenuItem value="pause">Pause</MenuItem>
                </TextField>
              </Grid>
              <Grid item xs={12}><Button type="submit" variant="contained" color="info" sx={{ padding: "10px", marginTop: "10px", color: 'white' }}>Add Schedule</Button></Grid>
            </Grid>
          </form>
        </Box>
      </Modal>
      <Modal open={scheduleEditModal} onClose={handleCloseEditScheduleModal} BackdropProps={{ onClick: (event) => event.stopPropagation() }}>
        <Box sx={modalStyle}>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}><h3>Edit Schedule</h3><Cancel onClick={handleCloseEditScheduleModal} sx={{ cursor: 'pointer' }} /></Box>
          <form onSubmit={handleEditSmsScheduleSubmit}>
            {selectedItem && (
              <Grid container spacing={1}>
                <Grid item xs={6}>
                  <TextField label="Schedule Name" fullWidth required name='schedule_name' sx={{ marginTop: "5px" }} value={selectedItem.schedule_name || ""} onChange={handleInputModChange} />
                  <TextField required name='schedule_id' sx={{ display: 'none!important' }} value={selectedItem.schedule_id || ""} onChange={handleInputModChange} />
                </Grid>
                <Grid item xs={6}>
                  <TextField fullWidth select label="Campaign" name="campaign_id" sx={{ marginTop: "5px" }} value={selectedItem.campaign_id || ""} onChange={handleInputModChange}>
                    <MenuItem value="" disabled>Select Campaign</MenuItem>
                    {campaignContactList.map((c, i) => <MenuItem key={i} value={c.campaign_id}>{c.campaign_name}</MenuItem>)}
                  </TextField>
                </Grid>
                <Grid item xs={6}><TextField label="Schedule Date & Time" fullWidth name='schedule_time' required value={selectedItem.schedule_time || ""} onChange={handleInputModChange} sx={{ marginTop: "5px" }} type="datetime-local" InputLabelProps={{ shrink: true }} /></Grid>
                <Grid item xs={6}>
                  <TextField fullWidth select label="Status" name="status" sx={{ marginTop: "5px" }} value={selectedItem.status || ""} onChange={handleInputModChange}>
                    <MenuItem value="" disabled>Status</MenuItem>
                    <MenuItem value="scheduled">Schedule</MenuItem>
                    <MenuItem value="pause">Pause</MenuItem>
                  </TextField>
                </Grid>
                <Grid item xs={6}><Button type="submit" variant="contained" color='info' sx={{ padding: "10px", marginTop: "10px", width: "100%" }}>Edit Schedule</Button></Grid>
                <Grid item xs={6}><Button type="button" variant="contained" color='error' sx={{ padding: "10px", marginTop: "10px", width: "100%" }} onClick={() => handleSmsScheduleDelete(selectedItem.id)}>Delete Schedule</Button></Grid>
              </Grid>
            )}
          </form>
        </Box>
      </Modal>
      
      {/* 🔔 Webchat Snackbar Notification */}
      <Snackbar open={webchatSnackbar.open} autoHideDuration={8000} onClose={handleCloseWebchatSnackbar} anchorOrigin={{ vertical: 'top', horizontal: 'right' }} action={<Button color="inherit" size="small" onClick={handleNavigateToWebchat} sx={{ fontWeight: 'bold' }}>View Chat</Button>}>
        <Alert onClose={handleCloseWebchatSnackbar} severity="info" variant="filled" icon={<Chat />} sx={{ width: '100%', cursor: 'pointer', '&:hover': { opacity: 0.95 } }} onClick={handleNavigateToWebchat}>
          <strong>{webchatSnackbar.sender}</strong>: {webchatSnackbar.message.length > 80 ? webchatSnackbar.message.slice(0, 80) + '...' : webchatSnackbar.message}
        </Alert>
      </Snackbar>
      <Snackbar open={openWait} anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}>
        <Alert severity="info" onClose={handleClose}>Sending message, please wait...</Alert>
      </Snackbar>
      <Snackbar open={openSuccess} autoHideDuration={4000} onClose={handleClose} anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}>
        <Alert severity="success" onClose={handleClose}>Message sent successfully!</Alert>
      </Snackbar>
      <Snackbar open={openError} autoHideDuration={4000} onClose={handleClose} anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}>
        <Alert severity="error" onClose={handleClose}>Failed to send message. Please try again.</Alert>
      </Snackbar>
    </>
  );
};

export default Integrations;